import {SharedModule} from "./shared.module";
import {EmployeeComponent} from "../home/employee/employee.component";
import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {DlgAskYesNoQuestion} from "./DlgAskYesNoQuestion";
import {DlgEditEmployeeComponent} from "../home/employee/DlgEditEmployeeComponent";
import {TextMaskModule} from "angular2-text-mask";
import {DlgEditAbsencesComponent} from "../home/employee/DlgEditAbsencesComponent";
import {
  DlgEditEmployeeAvailabilityAndDetailsComponent
} from "../home/employee/DlgEditEmployeeAvailabilityAndDetailsComponent";
import {
  DlgEditEmployeeAvailabilitySpecialComponent
} from "../home/employee/DlgEditEmployeeAvailabilitySpecialComponent";
import {DlgEditEmployeeContactComponent} from "../home/employee/DlgEditEmployeeContactComponent";
import {DlgEditEmployeeDocumentComponent} from "../home/employee/DlgEditEmployeeDocumentComponent";
import {DlgEditEmployeeJobComponent} from "../home/employee/DlgEditEmployeeJobComponent";
import {DlgEditEmployeeScheduleComponent} from "../home/schedule/DlgEditEmployeeScheduleComponent";
import {DlgEditEmployeeSickDaysComponent} from "../home/employee/DlgEditEmployeeSickDaysComponent";
import {DlgEditEmployeeVacationComponent} from "../home/employee/DlgEditEmployeeVacationComponent";
import {DlgEditHiringComponent} from "../home/employee/DlgEditHiringComponent";
import {DlgEditHiringDetailComponent} from "../home/employee/DlgEditHiringDetailComponent";
import {DlgEditPayParamsAggregationComponent} from "../home/employee/DlgEditPayParamsAggregationComponent";
import {DlgEditRemunerationDetailComponent} from "../home/employee/DlgEditRemunerationDetailComponent";
import {DlgEditRemunerationComponent} from "../home/employee/DlgEditRemunerationComponent";
import {DlgEditPunchAndPortalParametersComponent} from "../home/employee/DlgEditPunchAndPortalParametersComponent";
import {DlgListEmployeeJobAggregationComponent} from "../home/employee/DlgListEmployeeJobAggregationComponent";
import {DlgListEmployeeDocumentComponent} from "../home/employee/DlgListEmployeeDocumentComponent";
import {DlgListEmployeeContactComponent} from "../home/employee/DlgListEmployeeContactComponent";
import {
  DlgListEmployeeAvailabilitiesAggregationComponent
} from "../home/employee/DlgListEmployeeAvailabilitiesAggregationComponent";
import {DlgErrorMessage} from "./DlgErrorMessage";
import {CreateEmployeeComponent} from "../home/employee/create/create.employee.component";
import {WorkShiftCellComponent} from "../home/schedule/WorkShiftCellComponent";
import {WorkShiftRowHeaderComponent} from "../home/schedule/WorkShiftRowHeaderComponent";
import {WorkshiftPerEmployeeRowTotalComponent} from "../home/schedulePerEmployee/WorkshiftPerEmployeeRowTotalComponent";
import {
  WorkshiftPerEmployeeRowHeaderComponent
} from "../home/schedulePerEmployee/WorkshiftPerEmployeeRowHeaderComponent";
import {WorkshiftPerEmployeeCellComponent} from "../home/schedulePerEmployee/WorkshiftPerEmployeeCellComponent";
import {WorkedHoursTimesheetComponent} from "../home/timesheet/WorkedHoursTimesheetComponent";
import {
  SchedulePerUnitAndJobRowHeaderComponent
} from "../home/schedulePerUnitAndJob/SchedulePerUnitAndJobRowHeaderComponent";
import {
  ScheduleForAnEmployeeRowHeaderComponent
} from "../home/scheduleForAnEmployee/ScheduleForAnEmployeeRowHeaderComponent";
import {MealsTimesheetComponent} from "../home/timesheet/MealsTimesheetComponent";
import {EmployeeTimesheetComponent} from "../home/timesheet/EmployeeTimesheetComponent";
import {DivisionJobTimesheetComponent} from "../home/timesheet/DivisionJobTimesheetComponent";
import {CodeAndTypeTimesheetComponent} from "../home/timesheet/CodeAndTypeTimesheetComponent";
import {BreaksTimesheetComponent} from "../home/timesheet/BreaksTimesheetComponent";
import {WorkShiftRowTotalComponent} from "../home/schedule/WorkShiftRowTotalComponent";
import {NgDragDropModule} from "ng-drag-drop";
import {SchedulePerUnitAndJobComponent} from "../home/schedulePerUnitAndJob/SchedulePerUnitAndJobComponent";
import {WeeklySchedulePerUnitAndJobComponent} from "../home/schedulePerUnitAndJob/WeeklySchedulePerUnitAndJobComponent";
import {ScheduleForAnEmployeeComponent} from "../home/scheduleForAnEmployee/ScheduleForAnEmployeeComponent";
import {ScheduleComponent} from "../home/schedule/schedule.component";
import {DlgAddWorkshiftPerEmployeeComponent} from "../home/schedulePerEmployee/DlgAddWorkshiftPerEmployeeComponent";
import {DlgAddWorkshiftComponent} from "../home/schedule/DlgAddWorkshiftComponent";
import {DlgCopyWorkshiftComponent} from "../home/schedule/DlgCopyWorkshiftComponent";
import {DlgDisplayDaySchedule} from "../home/common/DlgDisplayDaySchedule";
import {DlgEditBatchItemVerificationComponent} from "../home/importing/DlgEditBatchItemVerificationComponent";
import {DlgWorkShiftRequestComponent} from "../home/memo/DlgWorkShiftRequestComponent";
import {DlgVacationRequestComponent} from "../home/memo/DlgVacationRequestComponent";
import {DlgSearchEmployeeComponent} from "../home/employee/DlgSearchEmployeeComponent";
import {DlgPunchImagesComponent} from "../home/timesheet/DlgPunchImagesComponent";
import {DlgPlainMessageComponent} from "../home/memo/DlgPlainMessageComponent";
import {DlgMapComponent} from "../home/timesheet/DlgMapComponent";
import {DlgEmployeeTimesheetLineComponent} from "../home/timesheet/DlgEmployeeTimesheetLineComponent";
import {DlgEmployeeScheduleComponent} from "../home/schedule/DlgEmployeeScheduleComponent";
import {DlgEmployeeBankComponent} from "../home/timesheet/DlgEmployeeBankComponent";
import {DlgEditUserComponent} from "../home/planning/DlgEditUserComponent";
import {DlgEditPlanningDetailComponent} from "../home/planning/DlgEditPlanningDetailComponent";
import {DlgEditPlanningAggregationComponent} from "../home/planning/DlgEditPlanningAggregationComponent";
import {DlgEditMemoAggregationComponent} from "../home/memo/DlgEditMemoAggregationComponent";
import {TimesheetComponent} from "../home/timesheet/timesheet.component";
import {WeeklyScheduleForAnEmployeeComponent} from "../home/scheduleForAnEmployee/WeeklyScheduleForAnEmployeeComponent";
import {WeeklyWorkShiftComponent} from "../home/schedule/WeeklyWorkShiftComponent";
import {WeeklyWorkshiftPerEmployeeComponent} from "../home/schedulePerEmployee/WeeklyWorkshiftPerEmployeeComponent";
import {DlgEmployeeTemplateComponent} from "../home/template/select/DlgEmployeeTemplateComponent";
import {TemplateEmployeeRowComponent} from "../home/template/TemplateEmployeeRowComponent";
import {TemplateEmployeeComponent} from "../home/template/TemplateEmployeeComponent";
import {TemplateForAnEmployeeRowHeaderComponent} from "../home/template/TemplateForAnEmployeeRowHeaderComponent";
import {TemplatePerEmployeeCellComponent} from "../home/template/TemplatePerEmployeeCellComponent";
import {TemplateEmployeeListComponent} from "../home/template/TemplateEmployeeListComponent";
import {TemplatePerEmployeeRowTotalComponent} from "../home/template/TemplatePerEmployeeRowTotalComponent";
import {SelectTemplateEmployeeComponent} from "../home/template/select/SelectTemplateEmployeeComponent";
import {SelectTemplateEmployeeRowComponent} from "../home/template/select/SelectTemplateEmployeeRowComponent";
import {CommonTemplateEmployeeRowComponent} from "../home/template/select/CommonTemplateEmployeeRowComponent";
import {DlgEditEmployeeVacationComponent2} from "../home/employee/DlgEditEmployeeVacationComponent2";
import {DlgMultipleEmployeeTemplateComponent} from "../home/template/select/DlgMultipleEmployeeTemplateComponent";
import {SelectMultipleTemplateEmployeeComponent} from "../home/template/select/SelectMultipleTemplateEmployeeComponent";
import {MultiSchedulePerEmployeeComponent} from "../home/schedulePerEmployee/multi.schedule.employee.component";
import {TotalHoursTimesheetComponent} from "../home/timesheet/TotalHoursTimesheetComponent";
import {DlgAddManualTimesheetComponent} from "../home/timesheet/manual/DlgAddManualTimesheetComponent";
import {DlgListEmployeeNoteComponent} from "../home/employee/DlgListEmployeeNoteComponent";
import {DlgEditEmployeeNoteComponent} from "../home/employee/DlgEditEmployeeNoteComponent";
import {DlgUserPreferencesComponent} from "../home/preferences/DlgUserPreferencesComponent";
import {UserPreferenceComponent} from "../home/preferences/UserPreferenceComponent";
import {PayComponent} from "../home/pay/pay.component";
import {PaySummaryExportComponent} from "../home/pay/PaySummaryExportComponent";
import {PayEmployeeExportComponent} from "../home/pay/PayEmployeeExportComponent";
import {PayStubsImportComponent} from "../home/pay/PayStubsImportComponent";
import {DlgEditEmployeeRightsComponent} from "../home/employee/DlgEditEmployeeRightsComponent";
import {DlgRawPayInformationForEmployeeComponent} from "../home/timesheet/DlgRawPayInformationForEmployeeComponent";
import {BonusComponent} from "../home/bonus/bonus.component";
import {DlgCumulativeBonusComponent} from "../home/bonus/DlgCumulativeBonusComponent";
import {DlgHourBonusComponent} from "../home/bonus/DlgHourBonusComponent";
import {ImportEmployeeNethrisFormatComponent} from "../home/employee/create/ImportEmployeeNethrisFormatComponent";
import {DlgChooseUnitComponent} from "../home/employee/create/DlgChooseUnitComponent";
import {ImportEmployeeNethrisAPIComponent} from "../home/employee/create/ImportEmployeeNethrisAPIComponent";
import {ImportOneEmployeeNethrisAPIComponent} from "../home/employee/create/ImportOneEmployeeNethrisAPIComponent";
import {DlgEditSchedulePrintConfigComponent} from "../home/schedulePerEmployee/DlgEditSchedulePrintConfigComponent";
import {DlgEmployeeBanksNethrisComponent} from "../home/employee/DlgEmployeeBanksNethrisComponent";
import {BatchComponent} from "../home/batch/batch.component";
import {DlgListPunchMessageComponent} from "../home/memo/punch/DlgListPunchMessageComponent";
import {DlgPunchMessageComponent} from "../home/memo/punch/DlgPunchMessageComponent";
import {EditCellComponent} from "../home/batch/EditCellComponent";
import {ChangeEmployeeVisibilityBatchComponent} from "../home/batch/ChangeEmployeeVisibilityBatchComponent";
import {CreateSickDaysBatchComponent} from "../home/batch/CreateSickDaysBatchComponent";
import {AdjustSalaryBatchComponent} from "../home/batch/AdjustSalaryBatchComponent";
import {DlgEditEmployeeGroupAggregationComponent} from "../home/group/DlgEditEmployeeGroupAggregationComponent";
import {GroupComponent} from "../home/group/group.component";
import {PayUpdateFromWebServiceComponent} from "../home/pay/PayUpdateFromWebServiceComponent";
import {
  MatchEmployeeWithMatriculeFromNethrisAPIComponent
} from "../home/employee/create/MatchEmployeeWithMatriculeFromNethrisAPIComponent";
import {RetrieveAndUpdateInfoFromPayrollComponent} from "../home/batch/RetrieveAndUpdateInfoFromPayrollComponent";
import {VacationEmployeeComponent} from "../home/vacation/vacation.employee.component";
import {VacationComponent} from "../home/vacation/VacationComponent";
import {DlgAddVacationComponent} from "../home/vacation/DlgAddVacationComponent";
import {VideoOnlineHelpComponent} from "../home/common/VideoOnlineHelpComponent";
import {DlgDisplayUserListComponent} from "../halfGod/DlgDisplayUserListComponent";
import {DlgChooseTimeZone} from "./DlgChooseTimeZone";
import {DlgListEmployeeSkillComponent} from "../home/employee/DlgListEmployeeSkillComponent";
import {CustomItemComponent} from "./CustomItemComponent";
import {AllTemplateComponent} from "../home/template/all.template.component";
import {MultiScheduleClassicComponent} from "../home/scheduleClassic/multi.schedule.classic.component";
import {
  WeeklyWorkshiftClassicPerEmployeeComponent
} from "../home/scheduleClassic/WeeklyWorkshiftClassicPerEmployeeComponent";
import {
  DisplayInfoEmployeeScheduleComponent
} from "../home/schedulePerEmployee/common/DisplayInfoEmployeeScheduleComponent";
import {SpifEmployeeComponent} from "../home/spif/spif.employee.component";
import {DlgAddEmployeeSpifComponent} from "../home/spif/DlgAddEmployeeSpifComponent";
import {DlgAddSpifTypeComponent} from "../home/spif/DlgAddSpifTypeComponent";
import {DlgSpifTypeComponent} from "../home/spif/DlgSpifTypeComponent";
import {EmployeeNotificationCenterComponent} from "../halfGod/EmployeeNotificationCenterComponent";
import {DlgExplainHolidayCalculationComponent} from "../halfGod/DlgExplainHolidayCalculationComponent";
import {DlgMoveJobComponent} from "../halfGod/DlgMoveJobComponent";
import {NamedWorkShiftComponent} from "../home/namedWorkshift/namedWorkShift.component";
import {DlgEditNamedWorkShiftComponent} from "../home/namedWorkshift/DlgEditNamedWorkShiftComponent";
import {OnlineHelpComponent} from "../home/common/OnlineHelpComponent";
import {DlgEditTimedTaskComponent} from "../home/task/DlgEditTimedTaskComponent";
import {DlgEditTimedTaskGroupAggregationComponent} from "../home/task/DlgEditTimedTaskGroupAggregationComponent";
import {TimedTasksComponent} from "../home/task/timedtasks.component";
import {Multi2ScheduleClassicComponent} from "../home/scheduleClassic/multi.2.schedule.classic.component";
import {EditUnitComponent} from "../halfGod/EditUnitComponent";
import {UnitAggregationComponent} from "../halfGod/UnitAggregationComponent";
import {DlgSelectEmployeeComponent} from "../halfGod/DlgSelectEmployeeComponent";
import {DlgEditDivisionComponent} from "../halfGod/DlgEditDivisionComponent";
import {DlgCreateJobComponent} from "../halfGod/DlgCreateJobComponent";
import {DlgCreateUnitComponent} from "../halfGod/DlgCreateUnitComponent";
import {DlgDisplayEmployeeJobListComponent} from "../halfGod/DlgDisplayEmployeeJobListComponent";
import {
  DlgDisplayEmployeeWorkingUnitAndDivisionListComponent
} from "../halfGod/DlgDisplayEmployeeWorkingUnitAndDivisionListComponent";
import {EmployeeTimedTaskParamsComponent} from "../home/task/EmployeeTimedTaskParamsComponent";
import {EmployeeTimedTaskComponent} from "../home/task/EmployeeTimedTaskComponent";
import {TimedTasksByProjectComponent} from "../home/task/timedtasks.project.component";
import {DlgMapTaskComponent} from "../home/task/DlgMapTaskComponent";
import {DlgPunchImagesForTaskComponent} from "../home/task/DlgPunchImagesForTaskComponent";
import {AdvancedPieChartComponent} from "../home/task/chart/advanced-pie-chart";
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {DlgForceAddJobComponent} from "../halfGod/DlgForceAddJobComponent";
import {DlgAllBanksFromEmployeeNethrisComponent} from "../halfGod/DlgAllBanksFromEmployeeNethrisComponent";
import {DlgTaskImagesComponent} from "../home/task/DlgTaskImagesComponent";
import {DlgEditTwoFactorAuthenticationComponent} from "../halfGod/DlgEditTwoFactorAuthenticationComponent";
import {ClassicTemplateEmployeeCellComponent} from "../home/template/classic/ClassicTemplateEmployeeCellComponent";
import {
  ClassicTemplateEmployeeRowTotalComponent
} from "../home/template/classic/ClassicTemplateEmployeeRowTotalComponent";
import {DlgEditPunchParamsComponent} from "../home/employee/shortcut/DlgEditPunchParamsComponent";
import {DlgEditTimesheetParamsComponent} from "../home/employee/shortcut/DlgEditTimesheetParamsComponent";
import {DlgCopyTemplatesComponent} from "../home/template/classic/DlgCopyTemplatesComponent";
import {AddSpifBatchComponent} from "../home/batch/AddSpifBatchComponent";
import {
  Multi2ScheduleClassicSideBarComponent
} from "../home/scheduleClassic/multi.2.schedule.classic.sidebar.component";
import {AllClassicTemplateSideBarComponent} from "../home/template/classic/all.classic.template.sidebar.component";
import {
  DlgEditCCQConfigurationForEmployeeComponent
} from "../home/employee/DlgEditCCQConfigurationForEmployeeComponent";
import {PaySummaryExportMultipleEnterpriseComponent} from "../home/pay/PaySummaryExportMultipleEnterpriseComponent";
import {SecurityPerUserComponent} from "../home/security/SecurityPerUserComponent";
import {DlgSecurityPerUserComponent} from "../home/security/DlgSecurityPerUserComponent";
import {CalculateHolidayComponent} from "../home/common/CalculateHolidayComponent";
import {ParamsProfileManagerComponent} from "../home/params/params-profile-manager.component";
import {DlgParamsProfileAggregationComponent} from "../home/params/DlgParamsProfileAggregationComponent";
import {DlgChangeUsernameOrBadgeNumberComponent} from "../halfGod/DlgChangeUsernameOrBadgeNumberComponent";
import {SendEmployeeToUDataBatchComponent} from "../home/batch/SendEmployeeToUDataBatchComponent";
import {ExportToRetailNextBatchComponent} from "../home/batch/ExportToRetailNextBatchComponent";
import {SurveysComponent} from "../home/survey/surveys.component";
import {DlgEditSurveyAggregationComponent} from "../home/survey/DlgEditSurveyAggregationComponent";
import {DlgEditSurveyQuestionComponent} from "../home/survey/DlgEditSurveyQuestionComponent";
import {DlgEditSurveyAnswerChoiceComponent} from "../home/survey/DlgEditSurveyAnswerChoiceComponent";
import {DlgEditSurveyAggregationTargetComponent} from "../home/survey/DlgEditSurveyAggregationTargetComponent";
import {DlgEditApiAccessComponent} from "../home/apiAccess/DlgEditApiAccessComponent";
import {AddOrModifyBonusBatchComponent} from "../home/batch/AddOrModifyBonusBatchComponent";
import {UnitJobForCumulativeBonusComponent} from "../home/bonus/UnitJobForCumulativeBonusComponent";
import {ListUnitJobCustomPayExportComponent} from "../home/pay/ListUnitJobCustomPayExportComponent";
import {DlgUnitJobCustomPayExportComponent} from "../home/pay/model/DlgUnitJobCustomPayExportComponent";
import {VacationRecordListComponent} from "../home/batch/VacationRecordListComponent";
import {ImageCropperComponent} from "./components/cropper/component/image-cropper.component";
import {DlgEditEmployeeOtherBadgeComponent} from "../home/employee/DlgEditEmployeeOtherBadgeComponent";
import {DlgListEmployeeOtherBadgeComponent} from "../home/employee/DlgListEmployeeOtherBadgeComponent";
import {BudgetComponent} from "../home/budget/budget.component";
import {EventComponent} from "../home/event/event.component";
import {DlgDayEventComponent} from "../home/event/DlgDayEventComponent";
import {DlgDaySalesCostObjectiveComponent} from "../home/sales/DlgDaySalesCostObjectiveComponent";
import {SalesComponent} from "../home/sales/sales.component";
import {DaySalesCostObjectiveComponent} from "../home/sales/DaySalesCostObjectiveComponent";
import {DlgEmprezMessageComponent} from "../home/emprez/DlgEmprezMessageComponent";
import {DayEventAggregationListComponent} from "../home/event/DayEventAggregationListComponent";
import {DlgDayEventAggregationListComponent} from "../home/event/DlgDayEventAggregationListComponent";
import {DayEventAggregationCellComponent} from "../home/event/DayEventAggregationCellComponent";
import {MemoAggregationComponent} from "../halfGod/memo/MemoAggregationComponent";
import {EditMemoAggregationComponent} from "../halfGod/memo/EditMemoAggregationComponent";
import {DlgNoteFromApproverComponent} from "../home/memo/DlgNoteFromApproverComponent";
import {ModifyLevelJobBatchComponent} from "../home/batch/ModifyLevelJobBatchComponent";
import {DlgEditPictureAlternateComponent} from "../home/pictures/DlgEditPictureAlternateComponent";
import {CreateHolidaysBatchComponent} from "../home/batch/CreateHolidaysBatchComponent";
import {LabelStickerComponent} from "./components/LabelStickerComponent";
import {Tooltip} from "./tooltip/Tooltip";
import {TooltipContent} from "./tooltip/TooltipContent";
import {CommitmentsComponent} from "../home/commitment/commitments.component";
import {DlgEditCommitmentAggregationComponent} from "../home/commitment/DlgEditCommitmentAggregationComponent";
import {PayTaxInformationImportComponent} from "../home/pay/PayTaxInformationImportComponent";
import {DlgShiftBonusComponent} from "../home/bonus/DlgShiftBonusComponent";
import {DlgWorkShiftBonusComponent} from "../home/bonus/DlgWorkShiftBonusComponent";
import {WorkShiftBonusListComponent} from "../home/bonus/WorkShiftBonusListComponent";
import {DlgDisplayUserPreferencesListComponent} from "../halfGod/prefs/DlgDisplayUserPreferencesListComponent";
import {AddOrModifyEmployeeBadgeComponent} from "../home/batch/AddOrModifyEmployeeBadgeComponent";
import {GeoFencesComponent} from "../home/geo/geofences.component";
import {DlgEditGeoFenceRightsForUserComponent} from "../home/geo/DlgEditGeoFenceRightsForUserComponent";
import {DlgEditGeoFenceComponent} from "../home/geo/DlgEditGeoFenceComponent";
import {DlgGeoFenceMapComponent} from "../home/geo/DlgGeoFenceMapComponent";
import {GeoFenceEmployeePositionListComponent} from "../home/geo/GeoFenceEmployeePositionListComponent";
import {DlgChooseGeoFenceComponent} from "../home/geo/DlgChooseGeoFenceComponent";
import {GeoFenceScheduleListComponent} from "../home/geo/GeoFenceScheduleListComponent";
import {GeoFenceScheduleComponent} from "../home/geo/GeoFenceScheduleComponent";
import {GeoFenceNamedWorkShiftComponent} from "../home/geo/GeoFenceNamedWorkShiftComponent";
import {GeoFenceNamedWorkShiftListComponent} from "../home/geo/GeoFenceNamedWorkShiftListComponent";
import {ChoosePlanningComponent} from "../home/planning/ChoosePlanningComponent";
import {DisplayPlanningComponent} from "../home/planning/DisplayPlanningComponent";
import {ChatRoomMemberListComponent} from "../home/chat/ChatRoomMemberListComponent";
import {DlgGeoFenceAgMapComponent} from "../home/geo/DlgGeoFenceAgMapComponent";
import {BankTypesComponent} from "../home/bank/bankTypes.component";
import {DlgChooseBankTypeComponent} from "../home/bank/DlgChooseBankTypeComponent";
import {DlgEditBankTypeComponent} from "../home/bank/DlgEditBankTypeComponent";
import {DlgEditBankTypeRightsForUserComponent} from "../home/bank/DlgEditBankTypeRightsForUserComponent";
import {DlgEditBankTypeEmployeeComponent} from "../home/bank/DlgEditBankTypeEmployeeComponent";
import {BankTypeEmployeeListComponent} from "../home/bank/BankTypeEmployeeListComponent";
import {BankTypeEmployeeTransactionListComponent} from "../home/bank/BankTypeEmployeeTransactionListComponent";
import {BankTypeEmployeeTransactionComponent} from "../home/bank/banktype.employee.transaction.component";
import {DlgEditBankTypeEmployeeTransactionComponent} from "../home/bank/DlgEditBankTypeEmployeeTransactionComponent";
import {CreateBankTypeEmployeeBatchComponent} from "../home/batch/CreateBankTypeEmployeeBatchComponent";
import {BankTypeEmployeeRecordListComponent} from "../home/batch/BankTypeEmployeeRecordListComponent";
import {DlgCreatePrivateChatChannelComponent} from "../home/chat/DlgCreatePrivateChatChannelComponent";
import {WebReportComponent} from "../home/reporting/WebReportComponent";
import {WebReportParamComponent} from "../home/reporting/WebReportParamComponent";
import {DisplayPayPeriodComponent} from "../home/common/DisplayPayPeriodComponent";
import {DlgImportSurveys} from "../home/survey/import/DlgImportSurveys";
import {DlgChooseEmployeeFromUnitAndJobComponent} from "../home/task/choose/DlgChooseEmployeeFromUnitAndJobComponent";
import {
  DlgCustomCumulativePremiumConfigurationComponent
} from "../home/bonus/custom/DlgCustomCumulativePremiumConfigurationComponent";
import {
  CustomCumulativePremiumConfiguration6000Component
} from "../home/bonus/custom/CustomCumulativePremiumConfiguration6000Component";
import {
  CustomCumulativePremiumConfigurationListComponent
} from "../home/bonus/custom/CustomCumulativePremiumConfigurationListComponent";
import {
  CustomCumulativePremiumConfigurationListItem
} from "../home/bonus/custom/CustomCumulativePremiumConfigurationListItem";
import {
  DlgChooseCustomCumulativePremiumConfigurationComponent
} from "../home/bonus/custom/DlgChooseCustomCumulativePremiumConfigurationComponent";
import {
  DlgEditEnterpriseCostDistributionConfigComponent
} from "../halfGod/DlgEditEnterpriseCostDistributionConfigComponent";
import {
  DlgRetrieveSegmentsConfigurationFromAPIComponent
} from "../home/pay/DlgRetrieveSegmentsConfigurationFromAPIComponent";
import {DlgSyncAPIConfigComponent} from "../home/pay/DlgSyncAPIConfigComponent";
import {MainHrKpiComponent} from "../home/hr/main-hr-kpi";
import {DlgEditEmployeeWorkAccidentComponent} from "../home/hr/DlgEditEmployeeWorkAccidentComponent";
import {EmployeeWorkAccidentComponent} from "../home/hr/EmployeeWorkAccidentComponent";
import {ListCustomCodeComponent} from "./ListCustomCodeComponent";
import {DlgChooseCustomCodes} from "./DlgChooseCustomCodes";
import {SelectCustomCodeComponent} from "./SelectCustomCodeComponent";
import {DlgEditPunchZkConfigurationComponent} from "../halfGod/zk/DlgEditPunchZkConfigurationComponent";
import {ZkCommandsListComponent} from "../halfGod/zk/ZkCommandsListComponent";
import {DlgEditZkCommandComponent} from "../halfGod/zk/DlgEditZkCommandComponent";
import {DlgEditZkPositionWorkCodeComponent} from "../halfGod/zk/DlgEditZkPositionWorkCodeComponent";
import {EditPunchZkConfigurationComponent} from "../halfGod/zk/EditPunchZkConfigurationComponent";
import {GraphAndDetailsComponent} from "../home/hr/GraphAndDetailsComponent";
import {DlgDisplayPerformancePerMonthComponent} from "../home/hr/DlgDisplayPerformancePerMonthComponent";
import {DashboardHrKpiComponent} from "../home/hr/DashboardHrKpiComponent";
import {ModulesListComponent} from "../halfGod/modules/modules.list.component";
import {DlgEditPlanningRightsForUserComponent} from "../home/planning/DlgEditPlanningRightsForUserComponent";
import {NonAuthorizedAbsencesComponent} from "../home/hr/components/NonAuthorizedAbsencesComponent";
import {MainHrKpiV2Component} from "../home/hr/main-hr-kpi-V2";
import {AuthorizedAbsencesComponent} from "../home/hr/components/AuthorizedAbsencesComponent";
import {AbsenteismComponent} from "../home/hr/components/AbsenteismComponent";
import {MoreTSThanScheduledComponent} from "../home/hr/components/MoreTSThanScheduledComponent";
import {LateArrivalComponent} from "../home/hr/components/LateArrivalComponent";
import {LateDepartureComponent} from "../home/hr/components/LateDepartureComponent";
import {ExtendedBreakComponent} from "../home/hr/components/ExtendedBreakComponent";
import {ExtendedMealComponent} from "../home/hr/components/ExtendedMealComponent";
import {NguiMapModule} from "./ngMap/ngui-map.module";
import {CustomReportListComponent} from "../home/reporting/list/customReport.list.component";
import {SendCredentialsByEmailBatchComponent} from "../home/batch/SendCredentialsByEmailBatchComponent";
import {DlgAddPunchComponent} from "../halfGod/DlgAddPunchComponent";
import {
  DlgEditEmployeFTempsSommaireDetailComponent
} from "../home/timesheet/DlgEditEmployeFTempsSommaireDetailComponent";
import {DlgExpenseTypeComponent} from "../home/expenses/DlgExpenseTypeComponent";
import {ExpensesTypesComponent} from "../home/expenses/expenses.types.component";
import {ExpensesComponent} from "../home/expenses/expenses.component";
import {DlgExpenseComponent} from "../home/expenses/DlgExpenseComponent";
import {SchedulePerPositionComponent} from "../home/schedulePerPosition/schedule.per.position.component";
import {DlgCloneEmployee} from "../home/employee/clone/DlgCloneEmployee";
import {
  CustomCumulativePremiumConfiguration6002Component
} from "../home/bonus/custom/CustomCumulativePremiumConfiguration6002Component";
import {HolidayListComponent} from "../home/holiday/holiday.list.component";
import {DlgAddEnterpriseStatutoryHolidayComponent} from "../home/holiday/DlgAddEnterpriseStatutoryHolidayComponent";
import {DlgCopyStatutoryHolidaysComponent} from "../home/holiday/DlgCopyStatutoryHolidaysComponent";
import {SpifComponent} from "../home/spif/spif.component";
import {AddWeeklySpifBatchComponent} from "../home/batch/AddWeeklySpifBatchComponent";
import {DlgEditSpifTypeRightsForUserComponent} from "../home/spif/DlgEditSpifTypeRightsForUserComponent";
import {
  CustomCumulativePremiumConfiguration6003Component
} from "../home/bonus/custom/CustomCumulativePremiumConfiguration6003Component";
import {EvaluationsComponent} from "../home/evaluation/evaluations.component";
import {DlgEditEvaluationAggregationComponent} from "../home/evaluation/DlgEditEvaluationAggregationComponent";
import {DlgEditEvaluationAnswerChoiceComponent} from "../home/evaluation/DlgEditEvaluationAnswerChoiceComponent";
import {DlgEditEvaluationQuestionComponent} from "../home/evaluation/DlgEditEvaluationQuestionComponent";
import {DlgEditEvaluationRightsForUserComponent} from "../home/evaluation/DlgEditEvaluationRightsForUserComponent";
import {EvaluationEmployeeListComponent} from "../home/evaluation/EvaluationEmployeeListComponent";
import {
  DlgEditEvaluationEmployeeAggregationComponent
} from "../home/evaluation/DlgEditEvaluationEmployeeAggregationComponent";
import {
  DlgEvaluateEvaluationEmployeeAggregationComponent
} from "../home/evaluation/DlgEvaluateEvaluationEmployeeAggregationComponent";
import {EvaluationQuestionComponent} from "../home/evaluation/EvaluationQuestionComponent";
import {DlgCreateStandardEvaluationComponent} from "../home/evaluation/DlgCreateStandardEvaluationComponent";
import {DlgCloneEmployeePositions} from "../home/employee/clone/DlgCloneEmployeePositions";
import {NotificationListComponent} from "../home/notify/NotificationListComponent";
import {EmployeeGroupListComponent} from "../home/group/EmployeeGroupListComponent";
import {EmployeeGroupComponent} from "../home/group/EmployeeGroupComponent";
import {DlgChooseGroupComponent} from "../home/group/DlgChooseGroupComponent";
import {
  ApprovableBankTypeRequestDashboardComponent
} from "../home/memo/component/ApprovableBankTypeRequestDashboardComponent";
import {
  ApprovableVacationRequestDashboardComponent
} from "../home/memo/component/ApprovableVacationRequestDashboardComponent";
import {
  ApprovableWorkShiftForShiftExchangeDashboardComponent
} from "../home/memo/component/ApprovableWorkShiftForShiftExchangeDashboardComponent";
import {
  ApprovableWorkShiftsForWorkshiftDashboardComponent
} from "../home/memo/component/ApprovableWorkShiftsForWorkshiftDashboardComponent";
import {
  PeriodicAvailabilitiesDashboardComponent
} from "../home/memo/component/PeriodicAvailabilitiesDashboardComponent";
import {SpecialAvailabilitiesDashboardComponent} from "../home/memo/component/SpecialAvailabilitiesDashboardComponent";
import {RequestListDashboardComponent} from "../home/memo/component/RequestListDashboardComponent";
import {PresenceComponent} from "../home/presence/presence.component";
import {DlgEditEmployeeGroupUserComponent} from "../home/group/DlgEditEmployeeGroupUserComponent";
import {ClassicEmployeeCellComponent} from "../home/scheduleClassic/ClassicEmployeeCellComponent";
import {EmployeeRowHeaderComponent} from "../home/schedulePerEmployee/EmployeeRowHeaderComponent";
import {EmployeeRowTotalComponent} from "../home/schedulePerEmployee/EmployeeRowTotalComponent";
import {
  ScheduleForAnEmployeeRowHeaderComponentNG
} from "../home/scheduleForAnEmployee/ScheduleForAnEmployeeRowHeaderComponentNG";
import {WorkshiftPerEmployeeCellComponentNG} from "../home/schedulePerEmployee/WorkshiftPerEmployeeCellComponentNG";
import {
  WorkshiftPerEmployeeRowTotalComponentNG
} from "../home/schedulePerEmployee/WorkshiftPerEmployeeRowTotalComponentNG";
import {
  WorkshiftPerEmployeeRowHeaderComponentNG
} from "../home/schedulePerEmployee/WorkshiftPerEmployeeRowHeaderComponentNG";
import {WorkShiftRowHeaderComponentNG} from "../home/schedule/WorkShiftRowHeaderComponentNG";
import {WorkShiftRowTotalComponentNG} from "../home/schedule/WorkShiftRowTotalComponentNG";
import {WorkShiftCellComponentNG} from "../home/schedule/WorkShiftCellComponentNG";
import {BreaksTimesheetComponentNG} from "../home/timesheet/BreaksTimesheetComponentNG";
import {CodeAndTypeTimesheetComponentNG} from "../home/timesheet/CodeAndTypeTimesheetComponentNG";
import {DivisionJobTimesheetComponentNG} from "../home/timesheet/DivisionJobTimesheetComponentNG";
import {EmployeeTimesheetComponentNG} from "../home/timesheet/EmployeeTimesheetComponentNG";
import {MealsTimesheetComponentNG} from "../home/timesheet/MealsTimesheetComponentNG";
import {TotalHoursTimesheetComponentNG} from "../home/timesheet/TotalHoursTimesheetComponentNG";
import {WorkedHoursTimesheetComponentNG} from "../home/timesheet/WorkedHoursTimesheetComponentNG";
import {TemplateForAnEmployeeRowHeaderComponentNG} from "../home/template/TemplateForAnEmployeeRowHeaderComponentNG";
import {TemplatePerEmployeeCellComponentNG} from "../home/template/TemplatePerEmployeeCellComponentNG";
import {TemplatePerEmployeeRowTotalComponentNG} from "../home/template/TemplatePerEmployeeRowTotalComponentNG";
import {ClassicTemplateEmployeeCellComponentNG} from "../home/template/classic/ClassicTemplateEmployeeCellComponentNG";
import {
  ClassicTemplateEmployeeRowHeaderComponentNG
} from "../home/template/classic/ClassicTemplateEmployeeRowHeaderComponentNG";
import {
  ClassicTemplateEmployeeRowTotalComponentNG
} from "../home/template/classic/ClassicTemplateEmployeeRowTotalComponentNG";
import {
  SchedulePerUnitAndJobRowHeaderComponentNG
} from "../home/schedulePerUnitAndJob/SchedulePerUnitAndJobRowHeaderComponentNG";
import {SelectPeriodComponent} from "./SelectPeriodComponent";
import {AddCumulativeBonusBatchComponent} from "../home/batch/AddCumulativeBonusBatchComponent";
import {AddJobBatchComponent} from "../home/batch/AddJobBatchComponent";
import {AllClassicTemplateComponent} from "../home/template/classic/all.classic.template.component";
import {ApiAccessesComponent} from "../home/apiAccess/apiAccesses.component";
import {ApprovableBankTypeRequestComponent} from "../home/memo/ApprovableBankTypeRequestComponent";
import {ApprovableBankTypeRequestListComponent} from "../home/memo/ApprovableBankTypeRequestListComponent";
import {BankTypeEmployeHoraireComponent} from "../home/bank/BankTypeEmployeHoraireComponent";
import {BankTypeForCumulativeBonusComponent} from "../home/bonus/BankTypeForCumulativeBonusComponent";
import {ChatComponent} from "../home/chat/chat.component";
import {ChatChannelComponent} from "../home/chat/ChatChannelComponent";
import {ChatMessageComponent} from "../home/chat/ChatMessageComponent";
import {ChatRoomComponent} from "../home/chat/ChatRoomComponent";
import {
  ClassicTemplateEmployeeRowHeaderComponent
} from "../home/template/classic/ClassicTemplateEmployeeRowHeaderComponent";
import {
  CommonClassicTemplateEmployeeRowComponent
} from "../home/template/classic/CommonClassicTemplateEmployeeRowComponent";
import {CreateVacationRecordComponent} from "../home/batch/CreateVacationRecordComponent";
import {CustomCodeComponent} from "./CustomCodeComponent";
import {
  CustomCumulativePremiumConfiguration6001Component
} from "../home/bonus/custom/CustomCumulativePremiumConfiguration6001Component";
import {DlgActivateListOfSurveys} from "../home/survey/DlgActivateListOfSurveys";
import {DlgAddEmployeeTimedTaskParamComponent} from "../home/task/DlgAddEmployeeTimedTaskParamComponent";
import {
  DlgAddManualTimesheetSelectedEmployeeComponent
} from "../home/timesheet/manual/DlgAddManualTimesheetSelectedEmployeeComponent";
import {
  DlgAddWorkshiftClassicPerEmployeeComponent
} from "../home/scheduleClassic/DlgAddWorkshiftClassicPerEmployeeComponent";
import {DlgChooseColor} from "./DlgChooseColor";
import {DlgChooseDateRange} from "./DlgChooseDateRange";
import {DlgChooseEmployeeComponent} from "../home/timesheet/manual/DlgChooseEmployeeComponent";
import {DlgChooseEnterpriseComponent} from "../home/employee/DlgChooseEnterpriseComponent";
import {DlgChooseUnitAndJobComponent} from "../home/common/DlgChooseUnitAndJobComponent";
import {DlgChooseUnitThatCanContainsJobsComponent} from "../home/common/DlgChooseUnitThatCanContainsJobsComponent";
import {DlgCreatePublicChannelComponent} from "../home/chat/DlgCreatePublicChannelComponent";
import {DlgEditBankTypeEmployeHoraireComponent} from "../home/bank/DlgEditBankTypeEmployeHoraireComponent";
import {DlgEditChatChannelComponent} from "../home/chat/DlgEditChatChannelComponent";
import {
  DlgEditCommitmentAggregationTargetComponent
} from "../home/commitment/DlgEditCommitmentAggregationTargetComponent";
import {DlgEditCustomReportForUserComponent} from "../home/reporting/list/DlgEditCustomReportForUserComponent";
import {DlgEditEmployeeSkillComponent} from "../home/employee/DlgEditEmployeeSkillComponent";
import {
  DlgEditNamedWorkShiftRightsForUserComponent
} from "../home/namedWorkshift/DlgEditNamedWorkShiftRightsForUserComponent";
import {DlgEditParamsProfileRightsForUserComponent} from "../home/params/DlgEditParamsProfileRightsForUserComponent";
import {DlgEditPictureComponent} from "../home/pictures/DlgEditPictureComponent";
import {DlgEditPortalParamsComponent} from "../home/employee/shortcut/DlgEditPortalParamsComponent";
import {DlgEditScheduleParamsComponent} from "../home/employee/shortcut/DlgEditScheduleParamsComponent";
import {DlgEditUsagerBudgetComponent} from "../home/employee/DlgEditUsagerBudgetComponent";
import {DlgEditUserPreferenceComponent} from "../halfGod/prefs/DlgEditUserPreferenceComponent";
import {DlgFindRecipientComponent} from "../home/chat/DlgFindRecipientComponent";
import {DlgListEmployeePerProjectComponent} from "../home/task/DlgListEmployeePerProjectComponent";
import {DlgNamedWorkShiftBonusComponent} from "../home/namedWorkshift/DlgNamedWorkShiftBonusComponent";
import {DlgNotifyEmployeeComponent} from "../home/notify/DlgNotifyEmployeeComponent";
import {DlgReportToEmailComponent} from "../home/reporting/DlgReportToEmailComponent";
import {DynamicComponent} from "../home/dynamic.component";
import {EmployeeJobCostDistributionComponent} from "../home/costDistribution/EmployeeJobCostDistributionComponent";
import {
  EmployeeTimedTaskParamsAggregationComponent
} from "../home/task/timedtasks.employee.params.aggregation.component";
import {
  EmployeHoraireCostDistributionComponent
} from "../home/costDistribution/EmployeHoraireCostDistributionComponent";
import {EmployeHrPerformanceComponent} from "../home/hr/EmployeHrPerformanceComponent";
import {GeoFenceEmployeePositionComponent} from "../home/geo/GeoFenceEmployeePositionComponent";
import {ImageCropperAlternateComponent} from "./components/ngx-img-cropper/imageCropperComponent";
import {ImportSurveyComponent} from "../home/survey/import/ImportSurveyComponent";
import {ModifyEmployeeSortOrderBatchComponent} from "../home/batch/ModifyEmployeeSortOrderBatchComponent";
import {
  MultiSchedulePerEmployeeSideBarComponent
} from "../home/schedulePerEmployee/multi.schedule.employee.sidebar.component";
import {PayExportComponent} from "../home/pay/PayExportComponent";
import {ReportToEmailListComponent} from "../home/reporting/ReportToEmailListComponent";
import {SchedulePerEmployeeComponent} from "../home/schedulePerEmployee/schedule.employee.component";
import {ScheduleSidebarComponent} from "../home/schedule/schedule.sidebar.component";
import {SegmentsConfigurationComponent} from "../home/pay/SegmentsConfigurationComponent";
import {SelectNamedWorkShiftComponent} from "../home/namedWorkshift/SelectNamedWorkShiftComponent";
import {TimedTasksPerEmployeeComponent} from "../home/task/timedtasks.employee.component";
import {TimesheetSideBarComponent} from "../home/timesheet/timesheet.sidebar.component";
import {VerifyEmployeeInformationComponent} from "../home/pay/VerifyEmployeeInformationComponent";
import {WorkShiftBonusComponent} from "../home/bonus/WorkShiftBonusComponent";
import {
  WorkshiftClassicPerEmployeeCellComponent
} from "../home/scheduleClassic/WorkshiftClassicPerEmployeeCellComponent";
import {IntuitImportEmployeeComponent} from "../home/intuit/IntuitImportEmployeeComponent";
import {CgiConnectComponent} from "./components/cgi-connect/CgiConnectComponent";
import {DlgCgiConnect} from "./components/cgi-connect/DlgCgiConnect";
import {MultiSelectDropdownComponent} from "./components/select/MultiSelectDropdownComponent";
import {TreeComponent} from "./components/tree/TreeComponent";
import {TreeItemComponent} from "./components/tree/TreeItemComponent";
import {DropdownTreeComponent} from "./components/tree/DropdownTreeComponent";
import {MenuItemComponent} from "./components/menu/MenuItemComponent";
import {DlgConfigureMenuFavorite} from "./components/menu/DlgConfigureMenuFavorite";
import {MatchEmployeeWithAllieRHComponent} from "../home/employee/create/MatchEmployeeWithAllieRHComponent";
import {ImportEmployeeAllieRHAPIComponent} from "../home/employee/create/ImportEmployeeAllieRHAPIComponent";
import {ImportOneEmployeeAllieRHAPIComponent} from "../home/employee/create/ImportOneEmployeeAllieRHAPIComponent";
import {
  DlgAddEnterpriseStatutoryHolidayByYearComponent
} from "../home/holiday/DlgAddEnterpriseStatutoryHolidayByYearComponent";
import {EmployeeWithTabComponent} from "../home/employee/employee.with.tab.component";
import {EmployeeTabComponent} from "../home/employee/tab/EmployeeTabComponent";
import {HiringTabComponent} from "../home/employee/tab/HiringTabComponent";
import {PositionsTabComponent} from "../home/employee/tab/PositionsTabComponent";
import {RemunerationTabComponent} from "../home/employee/tab/RemunerationTabComponent";
import {AbsencesTabComponent} from "../home/employee/tab/AbsencesTabComponent";
import {AvailabilitiesTabComponent} from "../home/employee/tab/AvailabilitiesTabComponent";
import {NotesTabComponent} from "../home/employee/tab/NotesTabComponent";
import {SkillsTabComponent} from "../home/employee/tab/SkillsTabComponent";
import {ParametersTabComponent} from "../home/employee/tab/ParametersTabComponent";
import {ContactsTabComponent} from "../home/employee/tab/ContactsTabComponent";
import {
  WorkshiftClassicPerEmployeeCellComponentNG
} from "../home/scheduleClassic/WorkshiftClassicPerEmployeeCellComponentNG";
import {CustomCellComponent} from "../home/schedulePerEmployee/common/CustomCellComponent";
import {ScheduleToolbarComponent} from "./components/toolbar/ScheduleToolbarComponent";
import {AlternateScheduleClassicComponent} from "../home/scheduleClassic/alternate.schedule.classic.component";
import {MobileAndWebAccessTabComponent} from "../home/employee/tab/MobileAndWebAccessTabComponent";
import {CCQTabComponent} from "../home/employee/tab/CCQTabComponent";
import {TimesheetParamsTabComponent} from "../home/employee/tab/TimesheetParamsTabComponent";
import {PayParamsTabComponent} from "../home/employee/tab/PayParamsTabComponent";
import {RPA360TabComponent} from "../home/employee/tab/RPA360TabComponent";
import {PayNethrisCustomerConfigComponent} from "../home/pay/PayNethrisCustomerConfigComponent";
import {DropdownForSelectedComponent} from "./components/select/DropdownForSelectedComponent";
import {AlternateParametersComponent} from "../home/params/alternate/alternate.parameters.component";
import {PunchParametersTabComponent} from "../home/params/alternate/tab/PunchParametersTabComponent";
import {ScheduleParametersTabComponent} from "../home/params/alternate/tab/ScheduleParametersTabComponent";
import {TimesheetParametersTabComponent} from "../home/params/alternate/tab/TimesheetParametersTabComponent";
import {PortailParametersTabComponent} from "../home/params/alternate/tab/PortailParametersTabComponent";
import {BonusTabComponent} from "../home/bonus/bonus.tab.component";
import {SpifTabComponent} from "../home/spif/spif.tab.component";
import {ParamsProfileManagerTabComponent} from "../home/params/params-profile-manager.tab.component";
import {NamedWorkShiftTabComponent} from "../home/namedWorkshift/namedWorkShift.tab.component";
import {SurveysTabComponent} from "../home/survey/surveys.tab.component";
import {GeoFencesTabComponent} from "../home/geo/geofences.tab.component";
import {BankTypesTabComponent} from "../home/bank/bankTypes.tab.component";
import {BankTypeEmployeeTransactionTabComponent} from "../home/bank/banktype.employee.transaction.tab.component";
import {ApiAccessesTabComponent} from "../home/apiAccess/apiAccesses.tab.component";
import {ReportToEmailListTabComponent} from "../home/reporting/ReportToEmailListTabComponent";
import {CustomReportListTabComponent} from "../home/reporting/list/customReport.list.tab.component";
import {ExpensesTypesTabComponent} from "../home/expenses/expenses.types.tab.component";
import {HolidayListTabComponent} from "../home/holiday/holiday.list.tab.component";
import {EvaluationsTabComponent} from "../home/evaluation/evaluations.tab.component";
import {AlternateReportingComponent} from "../home/reporting/alternate/alternate.reporting.component";
import {ReportEmployeeTabComponent} from "../home/reporting/alternate/tab/ReportEmployeeTabComponent";
import {ReportScheduleTabComponent} from "../home/reporting/alternate/tab/ReportScheduleTabComponent";
import {ReportBankTabComponent} from "../home/reporting/alternate/tab/ReportBankTabComponent";
import {ReportCostTabComponent} from "../home/reporting/alternate/tab/ReportCostTabComponent";
import {ReportCustomTabComponent} from "../home/reporting/alternate/tab/ReportCustomTabComponent";
import {ReportEmprezBITabComponent} from "../home/reporting/alternate/tab/ReportEmprezBITabComponent";
import {ReportHumanResourceTabComponent} from "../home/reporting/alternate/tab/ReportHumanResourceTabComponent";
import {ReportTimedTaskTabComponent} from "../home/reporting/alternate/tab/ReportTimedTaskTabComponent";
import {ReportTimesheetTabComponent} from "../home/reporting/alternate/tab/ReportTimesheetTabComponent";
import {AlternatePayComponent} from "../home/pay/alternate/alternate.pay.component";
import {PaySynchroFromFolksComponent} from "../home/pay/PaySynchroFromFolksComponent";
import {DlgSyncAPIConfigFolksComponent} from "../home/pay/DlgSyncAPIConfigFolksComponent";
import {EmployeeNotificationConfigurationComponent} from "../home/notify/EmployeeNotificationConfigurationComponent";
import {DlgEditText} from "./DlgEditText";
import {DlgDisplayPicture} from "./DlgDisplayPicture";
import {DlgRecordingAudio} from "./DlgRecordingAudio";
import {EmprezAiComponent} from "../home/ai/emprez.ai.component";
import {DlgEditEmployeeFamilyDaysComponent} from "../home/employee/DlgEditEmployeeFamilyDaysComponent";
import {CreateFamilyDaysBatchComponent} from "../home/batch/CreateFamilyDaysBatchComponent";
import {
  DlgAutoAttendanceMessageListComponent
} from "../home/timesheet/attendance/DlgAutoAttendanceMessageListComponent";
import {UpdateAutoAttendanceBatchComponent} from "../home/batch/UpdateAutoAttendanceBatchComponent";
import {DlgChooseCommitmentComponent} from "../home/commitment/DlgChooseCommitmentComponent";
import {EmployeDocumentLineComponent} from "../home/employee/document/employe.document.line.component";
import {DlgImportProject} from "../home/task/DlgImportProject";
import {ImportEmployeeOdooAPIComponent} from "../home/employee/create/ImportEmployeeOdooAPIComponent";
import {ImportOneEmployeeOdooAPIComponent} from "../home/employee/create/ImportOneEmployeeOdooAPIComponent";
import {MatchEmployeeWithOdooComponent} from "../home/employee/create/MatchEmployeeWithOdooComponent";
import {PaySynchroFromOdooComponent} from "../home/pay/PaySynchroFromOdooComponent";
import {DlgSyncAPIConfigOdooComponent} from "../home/pay/DlgSyncAPIConfigOdooComponent";
import {HamburgerMenuComponent} from "./components/hamburger/HamburgerMenuComponent";
import {AddGPSFenceOnPositionComponent} from "../home/batch/AddGPSFenceOnPositionComponent";
import {MatchEmployeeWithSageIntacctComponent} from "../home/employee/create/MatchEmployeeWithSageIntacctComponent";
import {ImportEmployeeSageIntacctAPIComponent} from "../home/employee/create/ImportEmployeeSageIntacctAPIComponent";
import {
  ImportOneEmployeeSageIntacctAPIComponent
} from "../home/employee/create/ImportOneEmployeeSageIntacctAPIComponent";
import {DlgRetrieveProjectFromSageIntacct} from "../home/task/DlgRetrieveProjectFromSageIntacct";
import {DlgImportProjectFromSageIntacctComponent} from "../home/task/DlgImportProjectFromSageIntacctComponent";
import {DlgReportTasksToSageIntacct} from "../home/task/DlgReportTasksToSageIntacct";
import {AlternateBatchComponent} from "../home/batch/alternate/alternate.batch.component";
import {AddAndDeleteInBatchTabComponent} from "../home/batch/alternate/tab/AddAndDeleteInBatchTabComponent";
import {ExtraToolsBatchTabComponent} from "../home/batch/alternate/tab/ExtraToolsBatchTabComponent";
import {ModifyInBatchTabComponent} from "../home/batch/alternate/tab/ModifyInBatchTabComponent";
import {WizAddWeeklySpifBatchComponent} from "../home/batch/alternate/wiz/WizAddWeeklySpifBatchComponent";
import {WizardBarComponent} from "./components/wizard/WizardBarComponent";
import {WizAddCumulativeBonusBatchComponent} from "../home/batch/alternate/wiz/WizAddCumulativeBonusBatchComponent";
import {WizAddJobBatchComponent} from "../home/batch/alternate/wiz/WizAddJobBatchComponent";
import {WizAddOrModifyBonusBatchComponent} from "../home/batch/alternate/wiz/WizAddOrModifyBonusBatchComponent";
import {WizAddOrModifyEmployeeBadgeComponent} from "../home/batch/alternate/wiz/WizAddOrModifyEmployeeBadgeComponent";
import {
  WizCreateBankTypeEmployeeBatchComponent
} from "../home/batch/alternate/wiz/WizCreateBankTypeEmployeeBatchComponent";
import {WizCreateHolidaysBatchComponent} from "../home/batch/alternate/wiz/WizCreateHolidaysBatchComponent";
import {WizCreateSickDaysBatchComponent} from "../home/batch/alternate/wiz/WizCreateSickDaysBatchComponent";
import {WizCreateFamilyDaysBatchComponent} from "../home/batch/alternate/wiz/WizCreateFamilyDaysBatchComponent";
import {WizCreateVacationRecordComponent} from "../home/batch/alternate/wiz/WizCreateVacationRecordComponent";
import {WizAdjustSalaryBatchComponent} from "../home/batch/alternate/wiz/WizAdjustSalaryBatchComponent";
import {
  WizChangeEmployeeVisibilityBatchComponent
} from "../home/batch/alternate/wiz/WizChangeEmployeeVisibilityBatchComponent";
import {WizModifyLevelJobBatchComponent} from "../home/batch/alternate/wiz/WizModifyLevelJobBatchComponent";
import {
  WizModifyEmployeeSortOrderBatchComponent
} from "../home/batch/alternate/wiz/WizModifyEmployeeSortOrderBatchComponent";
import {WizAddGPSFenceOnPositionComponent} from "../home/batch/alternate/wiz/WizAddGPSFenceOnPositionComponent";
import {WizUpdateAutoAttendanceBatchComponent} from "../home/batch/alternate/wiz/WizUpdateAutoAttendanceBatchComponent";
import {
  WizSendCredentialsByEmailBatchComponent
} from "../home/batch/alternate/wiz/WizSendCredentialsByEmailBatchComponent";
import {TimesheetAlternateComponent} from "../home/timesheet/timesheet.alternate.component";
import {WizVerifyEmployeeComponent} from "../home/batch/alternate/wiz/WizVerifyEmployeeComponent";
import {EmployeeSearchComponent} from "../home/employee/employee.search.component";
import {AlternateEmployeeCellComponent} from "../home/scheduleClassic/AlternateEmployeeCellComponent";
import {AlternateEmployeeRowHeaderComponent} from "../home/schedulePerEmployee/AlternateEmployeeRowHeaderComponent";
import {ExpensesAlternateComponent} from "../home/expenses/expenses.alternate.component";
import {ScheduleAlternateComponent} from "../home/schedule/schedule.alternate.component";
import {AlternateWorkShiftCellComponentNG} from "../home/schedule/AlternateWorkShiftCellComponentNG";
import {AlternateScheduleStructureComponent} from "../home/schedulePerEmployee/alternate.schedule.structure.component";
import {
  AlternateWorkshiftPerEmployeeCellComponentNG
} from "../home/schedulePerEmployee/AlternateWorkshiftPerEmployeeCellComponentNG";
import {
  AlternateClassicTemplateSideBarComponent
} from "../home/template/classic/alternate.classic.template.sidebar.component";
import {
  AlternateWorkshiftClassicPerEmployeeCellComponentNG
} from "../home/scheduleClassic/AlternateWorkshiftClassicPerEmployeeCellComponentNG";
import {
  AlternateScheduleForAnEmployeeComponent
} from "../home/scheduleForAnEmployee/AlternateScheduleForAnEmployeeComponent";
import {DlgChatMessage} from "./DlgChatMessage";
import {VerificationsComponent} from "../home/dashboard/verifications/verifications.component";
import {DlgSelectTimesheetToApprove} from "../home/dashboard/DlgSelectTimesheetToApprove";
import {TimesheetToolbarComponent} from "./components/toolbar/TimesheetToolbarComponent";
import {MultiLinkComponent} from "../home/employee/multitab/multi-link.component";
import {MultiTabComponent} from "../home/employee/multitab/multi-tab.component";
import {TimedTaskCostDistributionComponent} from "../home/costDistribution/TimedTaskCostDistributionComponent";
import {TimedTaskCCQComponent} from "../home/costDistribution/TimedTaskCCQComponent";
import {EmployeeTimedTaskButtonListComponent} from "../home/task/EmployeeTimedTaskButtonListComponent";
import {EmployeeTimedTaskButtonComponent} from "../home/task/EmployeeTimedTaskButtonComponent";
import {DlgAddEmployeeTimedTaskComponent} from "../home/task/DlgAddEmployeeTimedTaskComponent";
import {
  DlgApplyTimesheetParamsToEmployeeOfEnterprise
} from "../home/employee/DlgApplyTimesheetParamsToEmployeeOfEnterprise";
import {UnitAggregationComponentWithButtons} from "../halfGod/UnitAggregationComponentWithButtons";
import {SageIntacctConfigurationComponent} from "../home/pay/SageIntacctConfigurationComponent";
import {
  AlternateSchedulePerPositionComponent
} from "../home/schedulePerPosition/alternate.schedule.per.position.component";
import {ListHourlyPremiumsComponent} from "../home/employee/components/ListHourlyPremiumsComponent";
import {ListCumulativePremiumsComponent} from "../home/employee/components/ListCumulativePremiumsComponent";
import {HourlyPremiumComponent} from "../home/employee/components/HourlyPremiumComponent";
import {CumulativePremiumComponent} from "../home/employee/components/CumulativePremiumComponent";
import {DlgChooseCumulativePremiumComponent} from "../home/employee/components/DlgChooseCumulativePremiumComponent";
import {DlgChooseJobBonusComponent} from "../home/employee/components/DlgChooseJobBonusComponent";
import {
  CustomCumulativePremiumConfiguration6004Component
} from "../home/bonus/custom/CustomCumulativePremiumConfiguration6004Component";
import {DlgApplyToEmployeesComponent} from "./DlgApplyToEmployeesComponent";
import {WizModifyPunchParamsBatchComponent} from "../home/batch/alternate/wiz/WizModifyPunchParamsBatchComponent";
import {EmployeePunchParamsComponent} from "../home/common/EmployeePunchParamsComponent";
import {EmployeePortalParamsComponent} from "../home/common/EmployeePortalParamsComponent";
import {EmployeeScheduleParamsComponent} from "../home/common/EmployeeScheduleParamsComponent";
import {EmployeeTimesheetParamsComponent} from "../home/common/EmployeeTimesheetParamsComponent";
import {WizModifyXXXParamsBatchComponent} from "../home/batch/alternate/wiz/WizModifyXXXParamsBatchComponent";
import {WizModifyPortalParamsBatchComponent} from "../home/batch/alternate/wiz/WizModifyPortalParamsBatchComponent";
import {WizModifyScheduleParamsBatchComponent} from "../home/batch/alternate/wiz/WizModifyScheduleParamsBatchComponent";
import {
  WizModifyTimesheetParamsBatchComponent
} from "../home/batch/alternate/wiz/WizModifyTimesheetParamsBatchComponent";
import {EmployeeToCreateOrImportComponent} from "../home/employee/create/EmployeeToCreateOrImportComponent";
import {
  EmployeeToCreateOrImportExternalComponent
} from "../home/employee/create/EmployeeToCreateOrImportExternalComponent";
import {
  WizCreateOrRemoveEvaluationBatchComponent
} from "../home/batch/alternate/wiz/WizCreateOrRemoveEvaluationBatchComponent";
import {DocumentCenterComponent} from "../home/document/document.center.component";
import {DocumentListComponent} from "../home/document/document.list.component";
import {
  DlgEditCommitmentAggregationWithTargetComponent
} from "../home/commitment/DlgEditCommitmentAggregationWithTargetComponent";
import {CommitmentsListComponent} from "../home/commitment/commitments.list.component";
import {CenterCommitmentListComponent} from "../home/document/center.commitment.list.component";
import {CenterNoteListComponent} from "../home/document/center.note.list.component";
import {CenterExpenseListComponent} from "../home/expenses/center.expense.list.component";
import {MonthlyDateRangeComponent} from "./components/date-range/monthly-date-range.component";
import {CenterWorkAccidentListComponent} from "../home/hr/center.work.accident.list.component";
import {CenterAbsenceListComponent} from "../home/timesheet/center.absence.list.component";
import {CenterEmployeeRemunerationListComponent} from "../home/employee/center.employee.remuneration.list.component";
import {CenterEmployeeStatusListComponent} from "../home/employee/center.employee.status.list.component";
import {CenterDisciplineListComponent} from "../home/hr/discipline/center.discipline.list.component";
import {DlgDisciplineComponent} from "../home/hr/discipline/DlgDisciplineComponent";
import {DlgHRConfigParamComponent} from "../home/hr/core/DlgHRConfigParamComponent";
import {DlgGrievanceComponent} from "../home/hr/grievance/DlgGrievanceComponent";
import {DlgChooseGrievanceComponent} from "../home/hr/grievance/DlgChooseGrievanceComponent";
import {CenterGrievanceListComponent} from "../home/hr/grievance/center.grievance.list.component";
import {DlgImportPunchGroupCarburComponent} from "../home/custom/DlgImportPunchGroupCarburComponent";
import {LearningCenterComponent} from "../home/learning/learning.center.component";
import {CenterCertificateListComponent} from "../home/learning/center.certificate.list.component";
import {DlgCertificateComponent} from "../home/learning/DlgCertificateComponent";
import {CertificatComponent} from "../home/learning/component/CertificatComponent";
import {CertificatListComponent} from "../home/learning/component/CertificatListComponent";
import {DlgChooseCertificatComponent} from "../home/learning/component/DlgChooseCertificatComponent";
import {CenterEmployeeCertificateListComponent} from "../home/learning/center.employee.certificate.list.component";
import {DlgEditEmployeeCertificateAggregation} from "../home/learning/DlgEditEmployeeCertificateAggregation";
import {CenterTrainingProgramListComponent} from "../home/learning/center.training.program.list.component";
import {DlgEditTrainingProgramAggregationComponent} from "../home/learning/DlgEditTrainingProgramAggregationComponent";
import {DlgEditEmployeeTrainingProgramComponent} from "../home/learning/DlgEditEmployeeTrainingProgramComponent";
import {PerformanceCenterComponent} from "../home/performance/performance.center.component";
import {CenterEvaluationListComponent} from "../home/evaluation/center.evaluation.list.component";
import {CenterEvaluationEmployeeListComponent} from "../home/evaluation/center.evaluation.employee.list.component";
import {YearlyDateRangeComponent} from "./components/date-range/yearly-date-range.component";
import {CenterEmployeeAbilityListComponent} from "../home/performance/center.employee.ability.list.component";
import {DlgEditEmployeeAbilitiesAggregationComponent} from "../home/performance/DlgEditEmployeeAbilitiesAggregationComponent";
import {DlgChooseHRAbilityComponent} from "../home/performance/component/DlgChooseHRAbilityComponent";
import {HRAbilityListComponent} from "../home/performance/component/HRAbilityListComponent";
import {HRAbilityComponent} from "../home/performance/component/HRAbilityComponent";
import {EmployeeAbilityComponent} from "../home/performance/component/EmployeeAbilityComponent";
import {EmployeeAbilityListComponent} from "../home/performance/component/EmployeeAbilityListComponent";
import {DlgEditEmployeeAbilityComponent} from "../home/performance/component/DlgEditEmployeeAbilityComponent";
import {DlgHRAbilityComponent} from "../home/performance/component/DlgHRAbilityComponent";
import {CenterPerformanceTemplateListComponent} from "../home/performance/center.performance.template.list.component";
import {DlgEditHRPerformanceTemplateComponent} from "../home/performance/DlgEditHRPerformanceTemplateComponent";
import {DlgEmployeePerformance} from "../home/performance/DlgEmployeePerformance";
import {CenterEmployeePerformanceListComponent} from "../home/performance/center.employee.performance.list.component";
import {DlgEmployeePerformanceAggregation} from "../home/performance/DlgEmployeePerformanceAggregation";
import {EmployeeAbilityReviewComponent} from "../home/performance/component/EmployeeAbilityReviewComponent";
import {EmployeeAbilityReviewListComponent} from "../home/performance/component/EmployeeAbilityReviewListComponent";
import {DlgEditEmployeeAbilityReviewComponent} from "../home/performance/DlgEditEmployeeAbilityReviewComponent";
import {CenterEmployeeCompetencyListComponent} from "../home/performance/center.employee.competency.list.component";
import {CenterEmployeeKraListComponent} from "../home/performance/center.employee.kra.list.component";
import {
  DlgEditEmployeeCompetenciesAggregationComponent
} from "../home/performance/DlgEditEmployeeCompetenciesAggregationComponent";
import {DlgEditEmployeeCompetencyComponent} from "../home/performance/component/DlgEditEmployeeCompetencyComponent";
import {EmployeeCompetencyComponent} from "../home/performance/component/EmployeeCompetencyComponent";
import {EmployeeCompetencyListComponent} from "../home/performance/component/EmployeeCompetencyListComponent";
import {DlgHRCompetencyComponent} from "../home/performance/component/DlgHRCompetencyComponent";
import {DlgEditEmployeeKRAsAggregationComponent} from "../home/performance/DlgEditEmployeeKRAsAggregationComponent";
import {DlgEditEmployeeKRAComponent} from "../home/performance/component/DlgEditEmployeeKRAComponent";
import {DlgHRKeyResponsibilityAreaComponent} from "../home/performance/component/DlgHRKeyResponsibilityAreaComponent";
import {EmployeeKRAComponent} from "../home/performance/component/EmployeeKRAComponent";
import {EmployeeKRAListComponent} from "../home/performance/component/EmployeeKRAListComponent";
import {EmployeeCompetencyReviewComponent} from "../home/performance/component/EmployeeCompetencyReviewComponent";
import {
  EmployeeCompetencyReviewListComponent
} from "../home/performance/component/EmployeeCompetencyReviewListComponent";
import {DlgRatingAndNoteComponent} from "./DlgRatingAndNoteComponent";
import {EmployeeKRAReviewComponent} from "../home/performance/component/EmployeeKRAReviewComponent";
import {EmployeeKRAReviewListComponent} from "../home/performance/component/EmployeeKRAReviewListComponent";
import {CenterEmployeeGoalListComponent} from "../home/performance/center.employee.goal.list.component";
import {DlgEditEmployeeGoalsAggregationComponent} from "../home/performance/DlgEditEmployeeGoalsAggregationComponent";
import {EmployeeGoalListComponent} from "../home/performance/component/EmployeeGoalListComponent";
import {EmployeeGoalComponent} from "../home/performance/component/EmployeeGoalComponent";
import {DlgEditEmployeeGoalComponent} from "../home/performance/component/DlgEditEmployeeGoalComponent";
import {EmployeeGoalReviewComponent} from "../home/performance/component/EmployeeGoalReviewComponent";
import {EmployeeGoalReviewListComponent} from "../home/performance/component/EmployeeGoalReviewListComponent";
import {EmployeeReview360ListComponent} from "../home/performance/component/EmployeeReview360ListComponent";
import {EmployeeReview360Component} from "../home/performance/component/EmployeeReview360Component";
import {DlgWebReportParamComponent} from "../home/reporting/DlgWebReportParamComponent";
import {CustomDateRangeComponent} from "./components/date-range/custom-date-range.component";
import {CenterGoalListComponent} from "../home/performance/center.goal.list.component";
import {KRAListComponent} from "../home/performance/component/core/KRAListComponent";
import {KRAComponent} from "../home/performance/component/core/KRAComponent";
import {GoalKPIListComponent} from "../home/performance/component/core/GoalKPIListComponent";
import {GoalKPIComponent} from "../home/performance/component/core/GoalKPIComponent";
import {DlgEditGoalKPIComponent} from "../home/performance/component/core/DlgEditGoalKPIComponent";
import {DlgEditGoalAggregationComponent} from "../home/performance/component/core/DlgEditGoalAggregationComponent";
import {DlgChooseAnythingComponent} from "../home/performance/component/DlgChooseAnythingComponent";
import {CenterKRAListComponent} from "../home/performance/center.kra.list.component";
import {DlgEditKRAAggregationComponent} from "../home/performance/component/core/DlgEditKRAAggregationComponent";
import {GoalComponent} from "../home/performance/component/core/GoalComponent";
import {GoalListComponent} from "../home/performance/component/core/GoalListComponent";
import {UnitKRAListComponent} from "../home/performance/component/core/UnitKRAListComponent";
import {UnitKRAComponent} from "../home/performance/component/core/UnitKRAComponent";
import {
  DlgEditEmployeeManagerAggregationComponent
} from "../home/performance/DlgEditEmployeeManagerAggregationComponent";
import {EmployeeManagerComponent} from "../home/performance/component/EmployeeManagerComponent";
import {EmployeeManagerListComponent} from "../home/performance/component/EmployeeManagerListComponent";
import {CenterEmployeeManagerListComponent} from "../home/performance/center.employee.manager.list.component";
import {DlgEmployeeKPIReviewsComponent} from "../home/performance/component/DlgEmployeeKPIReviewsComponent";
import {RatingAndNoteComponent} from "./RatingAndNoteComponent";
import {DlgEmployeeGoalReviewsComponent} from "../home/performance/component/DlgEmployeeGoalReviewsComponent";
import {CenterCareerListComponent} from "../home/learning/center.career.list.component";
import {DlgEditHRCareerAggregationComponent} from "../home/learning/component/DlgEditHRCareerAggregationComponent";
import {
  DlgEditEmployeeCareerAggregationComponent
} from "../home/learning/component/DlgEditEmployeeCareerAggregationComponent";
import {DlgEditHRCareerDetailComponent} from "../home/learning/component/DlgEditHRCareerDetailComponent";
import {HRCareerDetailComponent} from "../home/learning/component/HRCareerDetailComponent";
import {HRCareerDetailListComponent} from "../home/learning/component/HRCareerDetailListComponent";
import {CenterEmployeeCareerListComponent} from "../home/learning/center.employee.career.list.component";
import {CenterEmployeeRecognitionListComponent} from "../home/performance/center.employee.recognition.list.component";
import {DlgEditEmployeeRecognitionComponent} from "../home/performance/component/DlgEditEmployeeRecognitionComponent";
import {EmployeeRecognitionComponent} from "../home/performance/component/EmployeeRecognitionComponent";
import {EmployeeRecognitionListComponent} from "../home/performance/component/EmployeeRecognitionListComponent";
import {
  DlgEditEmployeeRecognitionAggregationComponent
} from "../home/performance/DlgEditEmployeeRecognitionAggregationComponent";
import {DlgEmployeePerformanceWithReviewers} from "../home/performance/DlgEmployeePerformanceWithReviewers";
import {
  EmployeePerformanceReviewerListComponent
} from "../home/performance/component/EmployeePerformanceReviewerListComponent";
import {EmployeePerformanceReviewerComponent} from "../home/performance/component/EmployeePerformanceReviewerComponent";
import {DashboardHrComponent} from "../home/dashboard/hr/dashboard.hr.component";
import {ApprovableFamilyDayRequestListComponent} from "../home/memo/ApprovableFamilyDayRequestListComponent";
import {ApprovableFamilyDayRequestComponent} from "../home/memo/ApprovableFamilyDayRequestComponent";
import {
  ApprovableFamilyDayRequestDashboardComponent
} from "../home/memo/component/ApprovableFamilyDayRequestDashboardComponent";
import {DlgWebPayRequestComponent} from "../home/pay/DlgWebPayRequestComponent";
import {SelectableLabelAndDescriptionComponent} from "./components/label/SelectableLabelAndDescriptionComponent";
import {DlgEditTimedTaskGroupUserComponent} from "../home/task/DlgEditTimedTaskGroupUserComponent";
import {DlgEnterpriseLogsComponent} from "./DlgEnterpriseLogsComponent";
import {DlgImportSchedulesOnTrackComponent} from "../home/custom/DlgImportSchedulesOnTrackComponent";
import {
  CustomCumulativePremiumConfiguration6005Component
} from "../home/bonus/custom/CustomCumulativePremiumConfiguration6005Component";
import {DlgChooseMultipleUnitAndJobComponent} from "../home/common/DlgChooseMultipleUnitAndJobComponent";
import {DlgChooseMultipleBankTypeComponent} from "../home/bank/DlgChooseMultipleBankTypeComponent";
import {
  CustomCumulativePremiumConfiguration6006Component
} from "../home/bonus/custom/CustomCumulativePremiumConfiguration6006Component";
import {
  CustomCumulativePremiumConfiguration6007Component
} from "../home/bonus/custom/CustomCumulativePremiumConfiguration6007Component";
import {
  CustomCumulativePremiumConfiguration6008Component
} from "../home/bonus/custom/CustomCumulativePremiumConfiguration6008Component";
import {
  CustomCumulativePremiumConfiguration6009Component
} from "../home/bonus/custom/CustomCumulativePremiumConfiguration6009Component";
import {DlgDisplayMemoStatistics} from "../home/memo/DlgDisplayMemoStatistics";
import {DlgNotifySelectedEmployeeComponent} from "../home/notify/DlgNotifySelectedEmployeeComponent";

@NgModule({
  declarations: [
    AbsencesTabComponent,
    AbsenteismComponent,
    AddAndDeleteInBatchTabComponent,
    AddCumulativeBonusBatchComponent,
    AddGPSFenceOnPositionComponent,
    AddJobBatchComponent,
    AddOrModifyBonusBatchComponent,
    AddOrModifyEmployeeBadgeComponent,
    AddSpifBatchComponent,
    AddWeeklySpifBatchComponent,
    AdjustSalaryBatchComponent,
    AdvancedPieChartComponent,
    AllClassicTemplateComponent,
    AllClassicTemplateSideBarComponent,
    AllTemplateComponent,
    AlternateBatchComponent,
    AlternateClassicTemplateSideBarComponent,
    AlternateEmployeeCellComponent,
    AlternateEmployeeRowHeaderComponent,
    AlternateParametersComponent,
    AlternatePayComponent,
    AlternateReportingComponent,
    AlternateScheduleClassicComponent, //Alternate
    AlternateScheduleForAnEmployeeComponent,
    AlternateSchedulePerPositionComponent,
    AlternateScheduleStructureComponent,
    AlternateWorkShiftCellComponentNG,
    AlternateWorkshiftClassicPerEmployeeCellComponentNG,
    AlternateWorkshiftPerEmployeeCellComponentNG,

    ApiAccessesComponent,
    ApiAccessesTabComponent,
    ApprovableBankTypeRequestComponent,
    ApprovableBankTypeRequestDashboardComponent,
    ApprovableFamilyDayRequestDashboardComponent,
    ApprovableBankTypeRequestListComponent,
    ApprovableFamilyDayRequestComponent,
    ApprovableFamilyDayRequestListComponent,
    ApprovableVacationRequestDashboardComponent,
    ApprovableWorkShiftForShiftExchangeDashboardComponent,
    ApprovableWorkShiftsForWorkshiftDashboardComponent,
    AuthorizedAbsencesComponent,
    AvailabilitiesTabComponent,
    BankTypeEmployeeListComponent,
    BankTypeEmployeeRecordListComponent,
    BankTypeEmployeeTransactionComponent,
    BankTypeEmployeeTransactionListComponent,
    BankTypeEmployeeTransactionTabComponent,
    BankTypeEmployeHoraireComponent,
    BankTypeForCumulativeBonusComponent,
    BankTypesComponent,
    BankTypesTabComponent,
    BatchComponent,
    BonusComponent,
    BonusTabComponent,
    BreaksTimesheetComponent,
    BreaksTimesheetComponentNG,
    BudgetComponent,
    CalculateHolidayComponent,
    CgiConnectComponent,
    ChangeEmployeeVisibilityBatchComponent,
    ChatComponent,
    ChatChannelComponent,
    ChatMessageComponent,
    ChatRoomComponent,
    ChatRoomMemberListComponent,
    ChoosePlanningComponent,
    CCQTabComponent,
    CenterAbsenceListComponent,
    CenterCareerListComponent,
    CenterCertificateListComponent,
    CenterCommitmentListComponent,
    CenterDisciplineListComponent,
    CenterEmployeeAbilityListComponent,
    CenterEmployeeCareerListComponent,
    CenterEmployeeCertificateListComponent,
    CenterEmployeeCompetencyListComponent,
    CenterEmployeeGoalListComponent,
    CenterEmployeeKraListComponent,
    CenterEmployeeRemunerationListComponent,
    CenterEmployeeStatusListComponent,
    CenterEvaluationEmployeeListComponent,
    CenterEvaluationListComponent,
    CenterExpenseListComponent,
    CenterGrievanceListComponent,
    CenterNoteListComponent,
    CenterEmployeePerformanceListComponent,
    CenterEmployeeRecognitionListComponent,
    CenterGoalListComponent,
    CenterKRAListComponent,
    CenterPerformanceTemplateListComponent,
    CenterTrainingProgramListComponent,
    CenterWorkAccidentListComponent,
    CertificatComponent,
    CertificatListComponent,
    ClassicEmployeeCellComponent,
    ClassicTemplateEmployeeCellComponent,
    ClassicTemplateEmployeeCellComponentNG,
    ClassicTemplateEmployeeRowHeaderComponent,
    ClassicTemplateEmployeeRowHeaderComponentNG,
    ClassicTemplateEmployeeRowTotalComponent,
    ClassicTemplateEmployeeRowTotalComponentNG,
    CodeAndTypeTimesheetComponent,
    CodeAndTypeTimesheetComponentNG,
    CommitmentsComponent,
    CommitmentsListComponent,
    CommonClassicTemplateEmployeeRowComponent,
    CustomCellComponent,
    CustomReportListComponent,
    CustomReportListTabComponent,
    CommonTemplateEmployeeRowComponent,
    ContactsTabComponent,
    CreateBankTypeEmployeeBatchComponent,
    CreateEmployeeComponent,
    CreateFamilyDaysBatchComponent,
    CreateHolidaysBatchComponent,
    CreateSickDaysBatchComponent,
    CreateVacationRecordComponent,
    CumulativePremiumComponent,
    CustomCodeComponent,
    CustomItemComponent,
    CustomCumulativePremiumConfiguration6000Component,
    CustomCumulativePremiumConfiguration6001Component,
    CustomCumulativePremiumConfiguration6002Component,
    CustomCumulativePremiumConfiguration6003Component,
    CustomCumulativePremiumConfiguration6004Component,
    CustomCumulativePremiumConfiguration6005Component,
    CustomCumulativePremiumConfiguration6006Component,
    CustomCumulativePremiumConfiguration6007Component,
    CustomCumulativePremiumConfiguration6008Component,
    CustomCumulativePremiumConfiguration6009Component,
    CustomCumulativePremiumConfigurationListComponent,
    CustomCumulativePremiumConfigurationListItem,
    DashboardHrComponent,
    DashboardHrKpiComponent,
    DayEventAggregationCellComponent,
    DayEventAggregationListComponent,
    DaySalesCostObjectiveComponent,
    DisplayInfoEmployeeScheduleComponent,
    DisplayPayPeriodComponent,

    DisplayPlanningComponent,
    DivisionJobTimesheetComponent,
    DivisionJobTimesheetComponentNG,
    DlgActivateListOfSurveys,
    DlgAddEmployeeSpifComponent,
    DlgAddEmployeeTimedTaskComponent,
    DlgAddEmployeeTimedTaskParamComponent,
    DlgAddEnterpriseStatutoryHolidayComponent,
    DlgAddEnterpriseStatutoryHolidayByYearComponent,
    DlgAddManualTimesheetComponent,
    DlgAddManualTimesheetSelectedEmployeeComponent,
    DlgAddPunchComponent,
    DlgAddSpifTypeComponent,
    DlgAddVacationComponent,
    DlgAddWorkshiftComponent,
    DlgAddWorkshiftClassicPerEmployeeComponent,
    DlgAddWorkshiftPerEmployeeComponent,
    DlgAllBanksFromEmployeeNethrisComponent,
    DlgApplyTimesheetParamsToEmployeeOfEnterprise,
    DlgApplyToEmployeesComponent,
    DlgAutoAttendanceMessageListComponent,
    DlgAskYesNoQuestion,
    DlgCertificateComponent,
    DlgChatMessage,
    DlgChooseAnythingComponent,
    DlgChooseCertificatComponent,
    DlgChooseHRAbilityComponent,
    DlgCgiConnect,
    DlgChangeUsernameOrBadgeNumberComponent,
    DlgChooseBankTypeComponent,
    DlgChooseColor,
    DlgChooseCommitmentComponent,
    DlgChooseCumulativePremiumComponent,
    DlgChooseCustomCodes,
    DlgChooseCustomCumulativePremiumConfigurationComponent,
    DlgChooseDateRange,
    DlgChooseEmployeeComponent,
    DlgChooseEmployeeFromUnitAndJobComponent,
    DlgChooseEnterpriseComponent,
    DlgChooseGeoFenceComponent,
    DlgChooseGrievanceComponent,
    DlgChooseGroupComponent,
    DlgChooseJobBonusComponent,
    DlgChooseMultipleBankTypeComponent,
    DlgChooseMultipleUnitAndJobComponent,
    DlgChooseUnitAndJobComponent,
    DlgChooseUnitComponent,
    DlgChooseUnitThatCanContainsJobsComponent,
    DlgChooseTimeZone,
    DlgCloneEmployee,
    DlgCloneEmployeePositions,
    DlgConfigureMenuFavorite,
    DlgCopyStatutoryHolidaysComponent,
    DlgCreateJobComponent,
    DlgCreateStandardEvaluationComponent,
    DlgCreateUnitComponent,
    DlgCopyTemplatesComponent,
    DlgCopyWorkshiftComponent,
    DlgCreatePublicChannelComponent,
    DlgCreatePrivateChatChannelComponent,
    DlgCumulativeBonusComponent,
    DlgCustomCumulativePremiumConfigurationComponent,
    DlgDayEventAggregationListComponent,
    DlgDayEventComponent,
    DlgDaySalesCostObjectiveComponent,
    DlgDisciplineComponent,
    DlgDisplayDaySchedule,
    DlgDisplayEmployeeJobListComponent,
    DlgDisplayEmployeeWorkingUnitAndDivisionListComponent,
    DlgDisplayMemoStatistics,
    DlgDisplayPerformancePerMonthComponent,
    DlgDisplayPicture,
    DlgDisplayUserListComponent,
    DlgDisplayUserPreferencesListComponent,
    DlgEditAbsencesComponent,
    DlgEditApiAccessComponent,
    DlgEditBankTypeComponent,
    DlgEditBankTypeEmployeeComponent,
    DlgEditBankTypeEmployeeTransactionComponent,
    DlgEditBankTypeEmployeHoraireComponent,
    DlgEditBankTypeRightsForUserComponent,
    DlgEditBatchItemVerificationComponent,
    DlgEditCCQConfigurationForEmployeeComponent,
    DlgEditChatChannelComponent,
    DlgEditCommitmentAggregationComponent,
    DlgEditCommitmentAggregationTargetComponent,
    DlgEditCommitmentAggregationWithTargetComponent,
    DlgEditCustomReportForUserComponent,
    DlgEditDivisionComponent,
    DlgEditEmployeeAbilitiesAggregationComponent,
    DlgEditEmployeeAbilityComponent,
    DlgEditEmployeeAbilityReviewComponent,
    DlgEditEmployeeAvailabilityAndDetailsComponent,
    DlgEditEmployeeAvailabilitySpecialComponent,
    DlgEditEmployeeCareerAggregationComponent,
    DlgEditEmployeeCertificateAggregation,
    DlgEditEmployeeCompetenciesAggregationComponent,
    DlgEditEmployeeCompetencyComponent,
    DlgEditEmployeeComponent,
    DlgEditEmployeeContactComponent,
    DlgEditEmployeeDocumentComponent,
    DlgEditEmployeeFamilyDaysComponent,
    DlgEditEmployeeGoalComponent,
    DlgEditEmployeeGoalsAggregationComponent,
    DlgEditEmployeeGroupAggregationComponent,
    DlgEditEmployeeGroupUserComponent,
    DlgEditEmployeeJobComponent,
    DlgEditEmployeeKRAsAggregationComponent,
    DlgEditEmployeeKRAComponent,
    DlgEditEmployeeManagerAggregationComponent,
    DlgEditEmployeeNoteComponent,
    DlgEditEmployeeOtherBadgeComponent,
    DlgEditEmployeeRecognitionAggregationComponent,
    DlgEditEmployeeRecognitionComponent,
    DlgEditEmployeeRightsComponent,
    DlgEditEmployeeScheduleComponent,
    DlgEditEmployeeSickDaysComponent,
    DlgEditEmployeeSkillComponent,
    DlgEditEmployeeTrainingProgramComponent,
    DlgEditEmployeeVacationComponent,
    DlgEditEmployeeVacationComponent2,
    DlgEditEmployeeWorkAccidentComponent,
    DlgEditEmployeFTempsSommaireDetailComponent,
    DlgEditEnterpriseCostDistributionConfigComponent,
    DlgEditEvaluationAggregationComponent,
    DlgEditEvaluationAnswerChoiceComponent,
    DlgEditEvaluationEmployeeAggregationComponent,
    DlgEditEvaluationQuestionComponent,
    DlgEditEvaluationRightsForUserComponent,
    DlgEditGeoFenceComponent,
    DlgEditGeoFenceRightsForUserComponent,
    DlgEditGoalAggregationComponent,
    DlgEditGoalKPIComponent,
    DlgEditHiringComponent,
    DlgEditHiringDetailComponent,
    DlgEditHRCareerAggregationComponent,
    DlgEditHRCareerDetailComponent,
    DlgEditHRPerformanceTemplateComponent,
    DlgEditKRAAggregationComponent,
    DlgEditMemoAggregationComponent,
    DlgEditNamedWorkShiftComponent,
    DlgEditNamedWorkShiftRightsForUserComponent,
    DlgEditParamsProfileRightsForUserComponent,
    DlgEditPayParamsAggregationComponent,
    DlgEditPictureAlternateComponent,
    DlgEditPictureComponent,
    DlgEditPlanningAggregationComponent,
    DlgEditPlanningDetailComponent,
    DlgEditPlanningRightsForUserComponent,
    DlgEditPortalParamsComponent,
    DlgEditPunchParamsComponent,
    DlgEditPunchAndPortalParametersComponent,
    DlgEditPunchZkConfigurationComponent,
    DlgEditRemunerationComponent,
    DlgEditRemunerationDetailComponent,
    DlgEditScheduleParamsComponent,
    DlgEditSchedulePrintConfigComponent,
    DlgEditSpifTypeRightsForUserComponent,
    DlgEditSurveyAggregationComponent,
    DlgEditSurveyAggregationTargetComponent,
    DlgEditSurveyAnswerChoiceComponent,
    DlgEditSurveyQuestionComponent,
    DlgEditText,
    DlgEditTimedTaskComponent,
    DlgEditTimedTaskGroupAggregationComponent,
    DlgEditTimedTaskGroupUserComponent,
    DlgEditTimesheetParamsComponent,
    DlgEditTrainingProgramAggregationComponent,
    DlgEditTwoFactorAuthenticationComponent,
    DlgEditUsagerBudgetComponent,
    DlgEditUserComponent,
    DlgEditUserPreferenceComponent,
    DlgEditZkCommandComponent,
    DlgEditZkPositionWorkCodeComponent,
    DlgEmployeeBankComponent,
    DlgEmployeeBanksNethrisComponent,
    DlgEmployeeGoalReviewsComponent,
    DlgEmployeeKPIReviewsComponent,
    DlgEmployeePerformance,
    DlgEmployeePerformanceAggregation,
    DlgEmployeePerformanceWithReviewers,
    DlgEmployeeScheduleComponent,
    DlgEmployeeTemplateComponent,
    DlgEmployeeTimesheetLineComponent,
    DlgEmprezMessageComponent,
    DlgEnterpriseLogsComponent,
    DlgErrorMessage,
    DlgEvaluateEvaluationEmployeeAggregationComponent,
    DlgExpenseComponent,
    DlgExpenseTypeComponent,
    DlgExplainHolidayCalculationComponent,
    DlgFindRecipientComponent,
    DlgForceAddJobComponent,
    DlgGeoFenceAgMapComponent,
    DlgGeoFenceMapComponent,
    DlgGrievanceComponent,
    DlgHourBonusComponent,
    DlgHRAbilityComponent,
    DlgHRCompetencyComponent,
    DlgHRConfigParamComponent,
    DlgHRKeyResponsibilityAreaComponent,
    DlgImportProject,
    DlgImportPunchGroupCarburComponent,
    DlgImportSchedulesOnTrackComponent,
    DlgRetrieveProjectFromSageIntacct,
    DlgImportProjectFromSageIntacctComponent,
    DlgImportSurveys,
    DlgListEmployeeAvailabilitiesAggregationComponent,
    DlgListEmployeeContactComponent,
    DlgListEmployeeDocumentComponent,
    DlgListEmployeeJobAggregationComponent,
    DlgListEmployeeNoteComponent,
    DlgListEmployeeOtherBadgeComponent,
    DlgListEmployeePerProjectComponent,
    DlgListEmployeeSkillComponent,
    DlgListPunchMessageComponent,
    DlgMapComponent,
    DlgMapTaskComponent,
    DlgMoveJobComponent,
    DlgMultipleEmployeeTemplateComponent,
    DlgNamedWorkShiftBonusComponent,
    DlgNoteFromApproverComponent,
    DlgNotifyEmployeeComponent,
    DlgNotifySelectedEmployeeComponent,
    DlgParamsProfileAggregationComponent,
    DlgPlainMessageComponent,
    DlgPunchImagesComponent,
    DlgPunchImagesForTaskComponent,
    DlgPunchMessageComponent,
    DlgRatingAndNoteComponent,
    DlgRawPayInformationForEmployeeComponent,
    DlgRecordingAudio,
    DlgReportTasksToSageIntacct,
    DlgReportToEmailComponent,
    DlgRetrieveSegmentsConfigurationFromAPIComponent,
    DlgSearchEmployeeComponent,
    DlgSecurityPerUserComponent,
    DlgSelectEmployeeComponent,
    DlgSelectTimesheetToApprove,
    DlgShiftBonusComponent,
    DlgSpifTypeComponent,
    DlgSyncAPIConfigComponent,
    DlgSyncAPIConfigFolksComponent,
    DlgSyncAPIConfigOdooComponent,
    DlgTaskImagesComponent,
    DlgUnitJobCustomPayExportComponent,
    DlgUserPreferencesComponent,
    DlgVacationRequestComponent,
    DlgWebPayRequestComponent,
    DlgWebReportParamComponent,
    DlgWorkShiftBonusComponent,
    DlgWorkShiftRequestComponent,
    DocumentCenterComponent,
    DocumentListComponent,
    DropdownForSelectedComponent,
    DropdownTreeComponent,
    DynamicComponent,
    EditCellComponent,
    EditMemoAggregationComponent,
    EditPunchZkConfigurationComponent,
    EditUnitComponent,
    EmployeeAbilityComponent,
    EmployeeAbilityListComponent,
    EmployeeAbilityReviewComponent,
    EmployeeAbilityReviewListComponent,
    EmployeeComponent,
    EmployeeCompetencyComponent,
    EmployeeCompetencyListComponent,
    EmployeeCompetencyReviewComponent,
    EmployeeCompetencyReviewListComponent,
    EmployeDocumentLineComponent,
    EmployeeTabComponent,
    EmployeeSearchComponent,
    EmployeeWithTabComponent,
    EvaluationEmployeeListComponent,
    EmployeeGoalComponent,
    EmployeeGoalListComponent,
    EmployeeGoalReviewComponent,
    EmployeeGoalReviewListComponent,
    EmployeeGroupComponent,
    EmployeeGroupListComponent,
    EmployeeJobCostDistributionComponent,
    EmployeeKRAComponent,
    EmployeeKRAListComponent,
    EmployeeKRAReviewComponent,
    EmployeeKRAReviewListComponent,
    EmployeeManagerComponent,
    EmployeeManagerListComponent,
    EmployeeNotificationCenterComponent,
    EmployeeNotificationConfigurationComponent,
    EmployeePerformanceReviewerComponent,
    EmployeePerformanceReviewerListComponent,
    EmployeePortalParamsComponent,
    EmployeePunchParamsComponent,
    EmployeeRecognitionComponent,
    EmployeeRecognitionListComponent,
    EmployeeReview360Component,
    EmployeeReview360ListComponent,
    EmployeeRowHeaderComponent,
    EmployeeScheduleParamsComponent,
    EmployeeTimesheetParamsComponent,
    EmployeeTimedTaskButtonComponent,
    EmployeeTimedTaskButtonListComponent,
    EmployeeTimedTaskComponent,
    EmployeeTimedTaskParamsAggregationComponent,
    EmployeeTimedTaskParamsComponent,
    EmployeeTimesheetComponent,
    EmployeeTimesheetComponentNG,
    EmployeeToCreateOrImportComponent,
    EmployeeToCreateOrImportExternalComponent,
    EmployeeWorkAccidentComponent,
    EmployeHoraireCostDistributionComponent,
    EmployeHrPerformanceComponent,
    EmployeeRowTotalComponent,
    EmprezAiComponent,
    EvaluationEmployeeListComponent,
    EvaluationQuestionComponent,
    EvaluationsComponent,
    EvaluationsTabComponent,
    EventComponent,
    ExpensesAlternateComponent,
    ExpensesComponent,
    ExpensesTypesComponent,
    ExpensesTypesTabComponent,
    ExportToRetailNextBatchComponent,
    ExtendedBreakComponent,
    ExtendedMealComponent,
    ExtraToolsBatchTabComponent,
    // EstablishmentProgressComponent,
    GeoFenceEmployeePositionComponent,
    GeoFenceEmployeePositionListComponent,
    GeoFenceNamedWorkShiftComponent,
    GeoFenceNamedWorkShiftListComponent,
    GeoFenceScheduleComponent,
    GeoFenceScheduleListComponent,
    GeoFencesComponent,
    GeoFencesTabComponent,
    GoalComponent,
    GoalKPIComponent,
    GoalKPIListComponent,
    GoalListComponent,
    GraphAndDetailsComponent,
    GroupComponent,
    HamburgerMenuComponent,
    HiringTabComponent,
    HolidayListComponent,
    HolidayListTabComponent,
    HourlyPremiumComponent,
    HRAbilityComponent,
    HRAbilityListComponent,
    HRCareerDetailComponent,
    HRCareerDetailListComponent,
    ImageCropperAlternateComponent,
    ImageCropperComponent,
    ImportEmployeeAllieRHAPIComponent,
    ImportEmployeeNethrisFormatComponent,
    ImportEmployeeNethrisAPIComponent,
    ImportEmployeeOdooAPIComponent,
    ImportEmployeeSageIntacctAPIComponent,
    ImportOneEmployeeAllieRHAPIComponent,
    ImportOneEmployeeNethrisAPIComponent,
    ImportOneEmployeeOdooAPIComponent,
    ImportOneEmployeeSageIntacctAPIComponent,
    ImportSurveyComponent,
    IntuitImportEmployeeComponent,
    KRAComponent,
    KRAListComponent,
    LabelStickerComponent,
    LateArrivalComponent,
    LateDepartureComponent,
    LearningCenterComponent,
    ListCumulativePremiumsComponent,
    ListHourlyPremiumsComponent,
    ListCustomCodeComponent,
    ListUnitJobCustomPayExportComponent,
    MainHrKpiComponent,
    MainHrKpiV2Component,
    MatchEmployeeWithAllieRHComponent,
    MatchEmployeeWithMatriculeFromNethrisAPIComponent,
    MatchEmployeeWithOdooComponent,
    MatchEmployeeWithSageIntacctComponent,
    MealsTimesheetComponent,
    MealsTimesheetComponentNG,
    MemoAggregationComponent,
    MenuItemComponent,
    MobileAndWebAccessTabComponent,
    ModifyEmployeeSortOrderBatchComponent,
    ModifyInBatchTabComponent,
    ModifyLevelJobBatchComponent,
    ModulesListComponent,
    MonthlyDateRangeComponent,
    MoreTSThanScheduledComponent,
    MultiLinkComponent,
    MultiScheduleClassicComponent,
    Multi2ScheduleClassicComponent,
    Multi2ScheduleClassicSideBarComponent,
    MultiSchedulePerEmployeeComponent,
    MultiSchedulePerEmployeeSideBarComponent,
    MultiSelectDropdownComponent,
    MultiTabComponent,
    NamedWorkShiftComponent,
    NamedWorkShiftTabComponent,
    NonAuthorizedAbsencesComponent,
    NotesTabComponent,
    NotificationListComponent,
    OnlineHelpComponent,
    ParametersTabComponent,
    ParamsProfileManagerComponent,
    ParamsProfileManagerTabComponent,
    PayComponent,
    PayEmployeeExportComponent,
    PayExportComponent,
    PayNethrisCustomerConfigComponent,
    PayParamsTabComponent,
    PayStubsImportComponent,
    PaySummaryExportComponent,
    PaySummaryExportMultipleEnterpriseComponent,
    PaySynchroFromFolksComponent,
    PaySynchroFromOdooComponent,
    PayTaxInformationImportComponent,
    PayUpdateFromWebServiceComponent,
    PerformanceCenterComponent,
    PeriodicAvailabilitiesDashboardComponent,
    PortailParametersTabComponent,
    PositionsTabComponent,
    RemunerationTabComponent,
    RetrieveAndUpdateInfoFromPayrollComponent,
    ReportToEmailListComponent,
    ReportToEmailListTabComponent,
    PresenceComponent,
    PunchParametersTabComponent,
    RatingAndNoteComponent,
    ReportBankTabComponent,
    ReportCostTabComponent,
    ReportCustomTabComponent,
    ReportEmployeeTabComponent,
    ReportEmprezBITabComponent,
    ReportHumanResourceTabComponent,
    ReportScheduleTabComponent,
    ReportTimedTaskTabComponent,
    ReportTimesheetTabComponent,
    RequestListDashboardComponent,
    RPA360TabComponent,
    SalesComponent,
    SageIntacctConfigurationComponent,
    ScheduleAlternateComponent,
    ScheduleComponent,
    ScheduleForAnEmployeeComponent,
    ScheduleForAnEmployeeRowHeaderComponent,
    ScheduleForAnEmployeeRowHeaderComponentNG,
    ScheduleParametersTabComponent,
    SchedulePerEmployeeComponent,
    SchedulePerPositionComponent,
    SchedulePerUnitAndJobRowHeaderComponent,
    SchedulePerUnitAndJobRowHeaderComponentNG,
    SchedulePerUnitAndJobComponent,
    ScheduleSidebarComponent,
    ScheduleToolbarComponent,
    SecurityPerUserComponent,
    SegmentsConfigurationComponent,
    SelectableLabelAndDescriptionComponent,
    SelectCustomCodeComponent,
    SelectMultipleTemplateEmployeeComponent,
    SelectNamedWorkShiftComponent,
    SelectPeriodComponent,
    SelectTemplateEmployeeComponent,
    SelectTemplateEmployeeRowComponent,
    SendCredentialsByEmailBatchComponent,
    SendEmployeeToUDataBatchComponent,
    SkillsTabComponent,
    SpecialAvailabilitiesDashboardComponent,
    SpifComponent,
    SpifEmployeeComponent,
    SpifTabComponent,
    SurveysComponent,
    SurveysTabComponent,
    TemplateEmployeeComponent,
    TemplateEmployeeListComponent,
    TemplateEmployeeRowComponent,
    TemplateForAnEmployeeRowHeaderComponent,
    TemplateForAnEmployeeRowHeaderComponentNG,
    TemplatePerEmployeeCellComponent,
    TemplatePerEmployeeCellComponentNG,
    TemplatePerEmployeeRowTotalComponent,
    TemplatePerEmployeeRowTotalComponentNG,
    TimedTaskCCQComponent,
    TimedTaskCostDistributionComponent,
    TimedTasksByProjectComponent,
    TimedTasksComponent,
    TimedTasksPerEmployeeComponent,

    TimesheetAlternateComponent,
    TimesheetComponent,
    TimesheetParametersTabComponent,
    TimesheetParamsTabComponent,
    TimesheetSideBarComponent,
    TimesheetToolbarComponent,
    Tooltip,
    TooltipContent,
    TotalHoursTimesheetComponent,
    TotalHoursTimesheetComponentNG,
    TreeComponent,
    TreeItemComponent,
    UpdateAutoAttendanceBatchComponent,
    UserPreferenceComponent,
    UnitJobForCumulativeBonusComponent,
    UnitAggregationComponent,
    UnitAggregationComponentWithButtons,
    UnitKRAComponent,
    UnitKRAListComponent,
    VacationComponent,
    VideoOnlineHelpComponent,
    VacationEmployeeComponent,
    VacationRecordListComponent,
    VerificationsComponent,
    VerifyEmployeeInformationComponent,
    WebReportComponent,
    WebReportParamComponent,
    WeeklyScheduleForAnEmployeeComponent,
    WeeklySchedulePerUnitAndJobComponent,
    WeeklyWorkShiftComponent,
    WeeklyWorkshiftPerEmployeeComponent,
    WeeklyWorkshiftClassicPerEmployeeComponent,
    WizAddCumulativeBonusBatchComponent,
    WizAddGPSFenceOnPositionComponent,
    WizAddJobBatchComponent,
    WizAddOrModifyBonusBatchComponent,
    WizAddOrModifyEmployeeBadgeComponent,
    WizAddWeeklySpifBatchComponent,
    WizAdjustSalaryBatchComponent,
    WizChangeEmployeeVisibilityBatchComponent,
    WizCreateBankTypeEmployeeBatchComponent,
    WizCreateFamilyDaysBatchComponent,
    WizCreateHolidaysBatchComponent,
    WizCreateOrRemoveEvaluationBatchComponent,
    WizCreateSickDaysBatchComponent,
    WizCreateVacationRecordComponent,
    WizModifyEmployeeSortOrderBatchComponent,
    WizModifyLevelJobBatchComponent,
    WizModifyPortalParamsBatchComponent,
    WizModifyPunchParamsBatchComponent,
    WizModifyScheduleParamsBatchComponent,
    WizModifyTimesheetParamsBatchComponent,
    WizModifyXXXParamsBatchComponent,
    WizSendCredentialsByEmailBatchComponent,
    WizUpdateAutoAttendanceBatchComponent,
    WizVerifyEmployeeComponent,
    WizardBarComponent,
    WorkedHoursTimesheetComponent,
    WorkedHoursTimesheetComponentNG,
    WorkShiftBonusComponent,
    WorkShiftBonusListComponent,
    WorkShiftCellComponent,
    WorkShiftCellComponentNG,
    WorkshiftClassicPerEmployeeCellComponent,
    WorkshiftClassicPerEmployeeCellComponentNG,
    WorkshiftPerEmployeeCellComponent,
    WorkshiftPerEmployeeCellComponentNG,
    WorkshiftPerEmployeeRowHeaderComponent,
    WorkshiftPerEmployeeRowHeaderComponentNG,
    WorkshiftPerEmployeeRowTotalComponent,
    WorkshiftPerEmployeeRowTotalComponentNG,
    WorkShiftRowHeaderComponent,
    WorkShiftRowHeaderComponentNG,
    WorkShiftRowTotalComponent,
    WorkShiftRowTotalComponentNG,
    YearlyDateRangeComponent,
    ZkCommandsListComponent,
    CenterEmployeeManagerListComponent
  ],
  // exports: [],
  /*
  entryComponents: [
    DlgActivateListOfSurveys,
    DlgAddEmployeeSpifComponent,
    DlgAddEmployeeTimedTaskComponent,
    DlgAddEmployeeTimedTaskParamComponent,
    DlgAddEnterpriseStatutoryHolidayComponent,
    DlgAddEnterpriseStatutoryHolidayByYearComponent,
    DlgAddManualTimesheetComponent,
    DlgAddManualTimesheetSelectedEmployeeComponent,
    DlgAddPunchComponent,
    DlgAddSpifTypeComponent,
    DlgAddVacationComponent,
    DlgAddWorkshiftComponent,
    DlgAddWorkshiftClassicPerEmployeeComponent,
    DlgAddWorkshiftPerEmployeeComponent,
    DlgAllBanksFromEmployeeNethrisComponent,
    DlgApplyTimesheetParamsToEmployeeOfEnterprise,
    DlgApplyToEmployeesComponent,
    DlgAskYesNoQuestion,
    DlgAutoAttendanceMessageListComponent,
    DlgChatMessage,
    DlgCertificateComponent,
    DlgChooseAnythingComponent,
    DlgChooseCertificatComponent,
    DlgChooseHRAbilityComponent,
    DlgCloneEmployee,
    DlgCloneEmployeePositions,
    DlgCgiConnect,
    DlgChangeUsernameOrBadgeNumberComponent,
    DlgChooseBankTypeComponent,
    DlgChooseColor,
    DlgChooseCommitmentComponent,
    DlgChooseCumulativePremiumComponent,
    DlgChooseCustomCodes,
    DlgChooseCustomCumulativePremiumConfigurationComponent,
    DlgChooseDateRange,
    DlgChooseEmployeeComponent,
    DlgChooseEmployeeFromUnitAndJobComponent,
    DlgChooseEnterpriseComponent,
    DlgChooseGeoFenceComponent,
    DlgChooseGrievanceComponent,
    DlgChooseGroupComponent,
    DlgChooseJobBonusComponent,
    DlgChooseTimeZone,
    DlgChooseUnitAndJobComponent,
    DlgChooseUnitComponent,
    DlgChooseUnitThatCanContainsJobsComponent,
    DlgConfigureMenuFavorite,
    DlgCopyStatutoryHolidaysComponent,
    DlgCopyTemplatesComponent,
    DlgCopyWorkshiftComponent,
    DlgCreateJobComponent,
    DlgCreatePublicChannelComponent,
    DlgCreatePrivateChatChannelComponent,
    DlgCreateStandardEvaluationComponent,
    DlgCreateUnitComponent,
    DlgCumulativeBonusComponent,
    DlgCustomCumulativePremiumConfigurationComponent,
    DlgDayEventAggregationListComponent,
    DlgDayEventComponent,
    DlgDaySalesCostObjectiveComponent,
    DlgDisciplineComponent,
    DlgDisplayDaySchedule,
    DlgDisplayEmployeeJobListComponent,
    DlgDisplayEmployeeWorkingUnitAndDivisionListComponent,
    DlgDisplayPerformancePerMonthComponent,
    DlgDisplayPicture,
    DlgDisplayUserListComponent,
    DlgDisplayUserPreferencesListComponent,
    DlgEditAbsencesComponent,
    DlgEditApiAccessComponent,
    DlgEditBankTypeComponent,
    DlgEditBankTypeEmployeeComponent,
    DlgEditBankTypeEmployeeTransactionComponent,
    DlgEditBankTypeEmployeHoraireComponent,
    DlgEditBankTypeRightsForUserComponent,
    DlgEditBatchItemVerificationComponent,
    DlgEditCCQConfigurationForEmployeeComponent,
    DlgEditChatChannelComponent,
    DlgEditCommitmentAggregationComponent,
    DlgEditCommitmentAggregationTargetComponent,
    DlgEditCommitmentAggregationWithTargetComponent,
    DlgEditCustomReportForUserComponent,
    DlgEditDivisionComponent,
    DlgEditEmployeeAbilitiesAggregationComponent,
    DlgEditEmployeeAbilityComponent,
    DlgEditEmployeeAbilityReviewComponent,
    DlgEditEmployeeAvailabilityAndDetailsComponent,
    DlgEditEmployeeAvailabilitySpecialComponent,
    DlgEditEmployeeComponent,
    DlgEditEmployeeCompetenciesAggregationComponent,
    DlgEditEmployeeCompetencyComponent,
    DlgEditEmployeeCertificateAggregation,
    DlgEditEmployeeContactComponent,
    DlgEditEmployeeDocumentComponent,
    DlgEditEmployeeFamilyDaysComponent,
    DlgEditEmployeeGoalComponent,
    DlgEditEmployeeGoalsAggregationComponent,
    DlgEditEmployeeGroupAggregationComponent,
    DlgEditEmployeeGroupUserComponent,
    DlgEditEmployeeJobComponent,
    DlgEditEmployeeKRAsAggregationComponent,
    DlgEditEmployeeKRAComponent,
    DlgEditEmployeeManagerAggregationComponent,
    DlgEditEmployeeNoteComponent,
    DlgEditEmployeeOtherBadgeComponent,
    DlgEditEmployeeRightsComponent,
    DlgEditEmployeeScheduleComponent,
    DlgEditEmployeeSickDaysComponent,
    DlgEditEmployeeSkillComponent,
    DlgEditEmployeeTrainingProgramComponent,
    DlgEditEmployeeVacationComponent,
    DlgEditEmployeeVacationComponent2,
    DlgEditEmployeeWorkAccidentComponent,
    DlgEditEmployeFTempsSommaireDetailComponent,
    DlgEditEnterpriseCostDistributionConfigComponent,
    DlgEditEvaluationAggregationComponent,
    DlgEditEvaluationAnswerChoiceComponent,
    DlgEditEvaluationEmployeeAggregationComponent,
    DlgEditEvaluationQuestionComponent,
    DlgEditEvaluationRightsForUserComponent,
    DlgEditGeoFenceComponent,
    DlgEditGeoFenceRightsForUserComponent,
    DlgEditGoalAggregationComponent,
    DlgEditGoalKPIComponent,
    DlgEditHiringComponent,
    DlgEditHiringDetailComponent,
    DlgEditHRCareerAggregationComponent,
    DlgEditHRPerformanceTemplateComponent,
    DlgEditKRAAggregationComponent,
    DlgEditMemoAggregationComponent,
    DlgEditNamedWorkShiftComponent,
    DlgEditNamedWorkShiftRightsForUserComponent,
    DlgEditParamsProfileRightsForUserComponent,
    DlgEditPayParamsAggregationComponent,
    DlgEditPictureAlternateComponent,
    DlgEditPictureComponent,
    DlgEditPlanningAggregationComponent,
    DlgEditPlanningDetailComponent,
    DlgEditPlanningRightsForUserComponent,
    DlgEditPortalParamsComponent,
    DlgEditPunchAndPortalParametersComponent,
    DlgEditPunchParamsComponent,
    DlgEditPunchZkConfigurationComponent,
    DlgEditRemunerationComponent,
    DlgEditRemunerationDetailComponent,
    DlgEditScheduleParamsComponent,
    DlgEditSchedulePrintConfigComponent,
    DlgEditSpifTypeRightsForUserComponent,
    DlgEditSurveyAggregationTargetComponent,
    DlgEditSurveyAnswerChoiceComponent,
    DlgEditSurveyAggregationComponent,
    DlgEditSurveyQuestionComponent,
    DlgEditText,
    DlgEditTimedTaskComponent,
    DlgEditTimedTaskGroupAggregationComponent,
    DlgEditTimesheetParamsComponent,
    DlgEditTrainingProgramAggregationComponent,
    DlgEditTwoFactorAuthenticationComponent,
    DlgEditUsagerBudgetComponent,
    DlgEditUserComponent,
    DlgEditUserPreferenceComponent,
    DlgEditZkCommandComponent,
    DlgEditZkPositionWorkCodeComponent,
    DlgEmployeeBanksNethrisComponent,
    DlgEmployeeBankComponent,
    DlgEmployeeGoalReviewsComponent,
    DlgEmployeeKPIReviewsComponent,
    DlgEmployeePerformance,
    DlgEmployeePerformanceAggregation,
    DlgEmployeeScheduleComponent,
    DlgEmployeeTemplateComponent,
    DlgEmployeeTimesheetLineComponent,
    DlgEmprezMessageComponent,
    DlgErrorMessage,
    DlgEvaluateEvaluationEmployeeAggregationComponent,
    DlgExpenseComponent,
    DlgExpenseTypeComponent,
    DlgExplainHolidayCalculationComponent,
    DlgForceAddJobComponent,
    DlgFindRecipientComponent,
    DlgGeoFenceAgMapComponent,
    DlgGeoFenceMapComponent,
    DlgGrievanceComponent,
    DlgImportPunchGroupCarburComponent,
    DlgImportSurveys,
    DlgHourBonusComponent,
    DlgHRAbilityComponent,
    DlgHRConfigParamComponent,
    DlgHRCompetencyComponent,
    DlgHRKeyResponsibilityAreaComponent,
    DlgImportProject,
    DlgReportTasksToSageIntacct,
    DlgRetrieveProjectFromSageIntacct,
    DlgImportProjectFromSageIntacctComponent,
    DlgListEmployeeAvailabilitiesAggregationComponent,
    DlgListEmployeeContactComponent,
    DlgListEmployeeDocumentComponent,
    DlgListEmployeeJobAggregationComponent,
    DlgListEmployeeNoteComponent,
    DlgListEmployeePerProjectComponent,
    DlgListEmployeeOtherBadgeComponent,
    DlgListEmployeeSkillComponent,
    DlgListPunchMessageComponent,
    DlgMapComponent,
    DlgMapTaskComponent,
    DlgMoveJobComponent,
    DlgMultipleEmployeeTemplateComponent,
    DlgNamedWorkShiftBonusComponent,
    DlgNoteFromApproverComponent,
    DlgNotifyEmployeeComponent,
    DlgParamsProfileAggregationComponent,
    DlgPlainMessageComponent,
    DlgPunchImagesComponent,
    DlgPunchImagesForTaskComponent,
    DlgPunchMessageComponent,
    DlgRatingAndNoteComponent,
    DlgRawPayInformationForEmployeeComponent,
    DlgRecordingAudio,
    DlgReportToEmailComponent,
    DlgRetrieveSegmentsConfigurationFromAPIComponent,
    DlgSearchEmployeeComponent,
    DlgSecurityPerUserComponent,
    DlgSelectEmployeeComponent,
    DlgSelectTimesheetToApprove,
    DlgShiftBonusComponent,
    DlgSpifTypeComponent,
    DlgSyncAPIConfigComponent,
    DlgSyncAPIConfigFolksComponent,
    DlgSyncAPIConfigOdooComponent,
    DlgTaskImagesComponent,
    DlgUnitJobCustomPayExportComponent,
    DlgUserPreferencesComponent,
    DlgVacationRequestComponent,
    DlgWebReportParamComponent,
    DlgWorkShiftBonusComponent,
    DlgWorkShiftRequestComponent,
  ],
  */
  exports: [

    ApprovableBankTypeRequestListComponent,
    ApprovableFamilyDayRequestListComponent,
    CustomCumulativePremiumConfigurationListItem,
    DashboardHrKpiComponent,
    DisplayPlanningComponent,
    // DropdownDirective,
    // DropdownToggleDirective,
    // DropdownMenuDirective,
    DropdownTreeComponent,
    EditCellComponent,
    EvaluationQuestionComponent,
    HamburgerMenuComponent,
    MenuItemComponent,
    MultiSelectDropdownComponent,
    OnlineHelpComponent,
    ReportBankTabComponent,
    ReportCostTabComponent,
    ReportCustomTabComponent,
    ReportEmployeeTabComponent,
    ReportEmprezBITabComponent,
    ReportHumanResourceTabComponent,
    ReportScheduleTabComponent,
    ReportTimedTaskTabComponent,
    ReportTimesheetTabComponent,
    RequestListDashboardComponent,
    SelectTemplateEmployeeRowComponent,
    SelectableLabelAndDescriptionComponent,
    TreeComponent,
    WebReportComponent,
    WebReportParamComponent,
    CustomReportListTabComponent,
    HamburgerMenuComponent,
    Tooltip,
    VerificationsComponent,
    DashboardHrComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgxChartsModule,
//        MultiselectDropdownModule,
    NgDragDropModule.forRoot(),
    NguiMapModule.forRoot({apiUrl: 'https://maps.google.com/maps/api/js?key=AIzaSyAsaSHZQgpZtswuN_zj084hf7u2nPrQfp8'}),
    SharedModule,
    TextMaskModule,
    TranslateModule.forRoot(),
    CustomDateRangeComponent,
  ],
  providers: [
    // {provide: NgbDatepickerI18n, useClass: DatePickerI18n}
  ]

})


export class ComponentModule {

  constructor( ) {
  //  console.log('ComponentModule created');
  }


}
